import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const homeTranslations = {
    en: 'Home',
    ru: 'Главная',
    fas: 'صفحه اصلی'
};

const routesTranslations = {
    en: {
        aboutUs: 'About Us',
        privateBanking: 'Private Banking',
        commercialBanking: 'Commercial Banking',
        cards: 'Cards',
        digitalAssetsBanking: 'Digital Assets Banking',
        tradeFinance: 'Trade Finance',
        faq: 'FAQ',
        contact: 'Contact'
    },
    ru: {
        aboutUs: 'О нас',
        privateBanking: 'Частный банкинг',
        commercialBanking: 'Коммерческий банкинг',
        cards: 'Карты',
        digitalAssetsBanking: 'Банковские цифровые активы',
        tradeFinance: 'Торговое финансирование',
        faq: 'Часто задаваемые вопросы',
        contact: 'Контакты'
    },
    fas: {
        aboutUs: 'درباره ما',
        privateBanking: 'بانکداری خصوصی',
        commercialBanking: 'بانکداری تجاری',
        cards: 'کارت ها',
        digitalAssetsBanking: 'دارایی های دیجیتال بانکی',
        tradeFinance: 'امور مالی تجارت',
        faq: 'سوالات متداول',
        contact: 'مخاطبین'
    }
};

const headerTranslations = {
    en: {
        login: 'Log In',
        openAccount: 'Open Account',
        back: 'Back',
        menu: 'Menu'
    },
    ru: {
        login: 'Войти',
        openAccount: 'Открыть счёт',
        back: 'Назад',
        menu: 'Меню'
    },
    fas: {
        login: 'وارد شوید',
        openAccount: 'یک حساب باز کنید',
        back: 'Назад',
        menu: 'Меню'
    }
};

const commonTranslations = {
    en: { toggleLang: 'Русский' },
    ru: { toggleLang: 'English' }
};

// heroTranslations
const heroTranslations = {
    en: {
        getStarted: 'Get started',
        learnMore: 'Learn more'
    },
    ru: {
        getStarted: 'Начать',
        learnMore: 'Узнать больше'
    },
    fas: {
        getStarted: 'شروع کنید',
        learnMore: 'بیشتر بدانید'
    }
};

// HOME
const homePageTranslations = {
    en: {
        heroTitle1: 'Discover a World of',
        heroTitle2: 'Financial Freedom!',
        heroDescription:
            'Discover a world of financial freedom with Wall Street IBU. We specialize in providing offshore banking solutions tailored to meet your needs. Enjoy privacy, security, and flexibility with our range of services.',
        whoWeAreTitle: 'Who we are?',
        whoWeAreParagraph1:
            'Wall Street IBU is an international private bank serving the unique needs of globally mobile and digitally active citizens, their families and their businesses.',
        whoWeAreParagraph2:
            'It is a thoroughly modern International Private Banking brand that boasts a long history and a long-term view of the future.',
        whoWeAreParagraph3:
            'The strength of our bank lies in the diversity of our International Private Bankers.',
        whoWeAreParagraph4:
            'Our team speaks a dozen languages and uses its skills to serve private and institutional customers by offering personalized relationships and individual financial solutions.',
        servicesWeProvideTitle: 'Services we provide',
        fastPaymentTitle: 'We Are Fast and Secure Payment Method',
        fastPaymentParagraph:
            'At Wall Street IBU, we believe in empowering individuals and businesses with exceptional offshore banking services. Established in 2022, we have built a reputation for trust, integrity, and innovation in the financial industry. Our team of experts is dedicated to helping you navigate the complexities of offshore banking with ease.',
        openAccountSectionHeading: 'WALL Street IBU',
        openAccountSectionParagraph:
            'is an International Private Bank serving the unique needs of globally mobile and digitally active citizens, their families and their businesses.',
        learnMoreBtn: 'Learn more',
        openAccountBtn: 'Open Account',

        //  CARD TRANSLATIONS (EN) 
        cards: {
            privateBanking: {
                short: 'PB',
                title: 'Private Banking',
                description:
                    'The hallmark of Private Banking is exemplary personal, bespoke service. No two clients are the same, so flexibility is a cornerstone. Tell us about the banking service you need, and your Wall Street Bank International Private Banker will put it in place. Not even challenging tasks can fluster us.',
            },
            commercialBanking: {
                short: 'CB',
                title: 'Commercial Banking',
                description:
                    'Businesses can also benefit from the private banking touch! If you are looking for a reliable global trade partner to help you handle transactions and create wealth across borders, talk to our expert bankers in the areas of complex payment transactions and trade finance.',
            },
            cardServices: {
                short: 'C',
                title: 'Cards',
                description:
                    'At Wall Street Ibu we allow you to protect, access and grow your wealth from anywhere in the world with an international bank account in a safe jurisdiction. To access your funds on the move, you will receive one or more global debit cards for seamless transactions.',
            },
            digitalAssets: {
                short: 'DAB',
                title: 'Digital Assets Banking',
                description:
                    'We provide comprehensive banking services for both established and startup companies from the blockchain and cryptocurrency world, as well as offering private banking services to high net worth individuals who are trading or investing in crypto assets.',
            },
            tradeFinance: {
                short: 'TF',
                title: 'Trade Finance',
                description:
                    'As a Wall Street Ibu corporate account holder, you are guaranteed direct contact with a Trade Finance and Documentary Credit expert. This way our clients have their instruments endorsed by prime banks without the undoubted inconvenience of having to deal with the large institutions.',
            },
        },
    },
    ru: {
        heroTitle1: 'Откройте мир',
        heroTitle2: 'Финансовой Свободы!',
        heroDescription:
            'Откройте для себя мир финансовой свободы с Wall Street IBU. Мы специализируемся на предоставлении оффшорных банковских решений, адаптированных под ваши нужды. Наслаждайтесь конфиденциальностью, безопасностью и гибкостью с нашим спектром услуг.',
        whoWeAreTitle: 'Кто мы?',
        whoWeAreParagraph1:
            'Wall Street IBU — это международный частный банк, обслуживающий уникальные потребности глобально мобильных и цифрово активных граждан, их семей и бизнеса.',
        whoWeAreParagraph2:
            'Это современный бренд международного частного банковского обслуживания, который имеет долгую историю и долгосрочный взгляд на будущее.',
        whoWeAreParagraph3:
            'Сила нашего банка заключается в разнообразии наших международных частных банкиров.',
        whoWeAreParagraph4:
            'Наша команда говорит на дюжине языков и использует свои навыки для обслуживания частных и институциональных клиентов, предлагая персонализированные отношения и индивидуальные финансовые решения.',
        servicesWeProvideTitle: 'Услуги, которые мы предоставляем',
        fastPaymentTitle: 'Мы быстрый и безопасный способ оплаты',
        fastPaymentParagraph:
            'В Wall Street IBU мы верим в то, что даем возможность людям и бизнесу с помощью исключительных офшорных банковских услуг. Основанные в 2022 году, мы заработали репутацию доверия, честности и инноваций в финансовой отрасли. Наша команда экспертов готова помочь вам легко разобраться в сложностях офшорного банкинга.',
        openAccountSectionHeading: 'WALL Street IBU',
        openAccountSectionParagraph:
            'является международным частным банком, обслуживающим уникальные потребности глобально мобильных и цифрово активных граждан, их семей и бизнеса.',
        learnMoreBtn: 'Узнать больше',
        openAccountBtn: 'Открыть счёт',

        // CARD
        cards: {
            privateBanking: {
                short: 'ЧБ',
                title: 'Частное банковское обслуживание',
                description:
                    'Отличительной чертой частного банковского обслуживания является образцовое, индивидуальное обслуживание. Нет двух одинаковых клиентов, поэтому гибкость является краеугольным камнем. Расскажите нам о банковской услуге, которая вам нужна, и ваш частный банкир Wall Street Bank International организует её. Даже самые сложные задачи не могут нас смутить.',
            },
            commercialBanking: {
                short: 'КБ',
                title: 'Коммерческое банковское обслуживание',
                description:
                    'Предприятия также могут воспользоваться услугами private banking! Если вы ищете надежного партнера в сфере глобальной торговли, который поможет вам осуществлять транзакции и создавать богатство через границы, обратитесь к нашим экспертам в области сложных платежных операций и торгового финансирования.',
            },
            cardServices: {
                short: 'К',
                title: 'Карты',
                description:
                    ' Wall Street IBU позволит вам защитить, получить доступ и приумножить свое состояние из любой точки мира, открыв международный банковский счет в безопасной юрисдикции. Чтобы получить доступ к своим средствам в дороге, вы получите одну или несколько глобальных дебетовых карт для беспрепятственного проведения операций.',
            },
            digitalAssets: {
                short: 'ЦАБ',
                title: 'Цифровые активы в банковском обслуживании',
                description:
                    'Мы предоставляем комплексные банковские услуги как уже существующим, так и начинающим компаниям из мира блокчейна и криптовалют, а также предлагаем частные банковские услуги состоятельным людям, которые торгуют или инвестируют в криптоактивы.',
            },
            tradeFinance: {
                short: 'ТФ',
                title: 'Торговое финансирование',
                description:
                    'Как держатель корпоративного счета в Wall Street Ibu, вы гарантированно получаете прямой контакт с экспертом по торговому финансированию и документарным аккредитивам. Таким образом, наши клиенты получают инструменты, одобренные ведущими банками, без несомненных неудобств, связанных с работой с крупными учреждениями.',
            },
        },
    },

    fas: {
        heroTitle1: 'ﺑﺎ ﺟﮭﺎﻧﯽ از آزادی',
        heroTitle2: 'ﻣﺎﻟﯽ آﺷﻨﺎ ﺷﻮﯾﺪ!',
        heroDescription:
            'در این بخش، وبسایت Wall Street IBU جهانی از آزادی مالی را معرفی میکند و تأکید دارد که با ارائه خدمات بانکداری',
        whoWeAreTitle: 'درباره ما',
        whoWeAreParagraph1:
            'وال استریت IBU — این یک بانک خصوصی بین‌المللی است که به نیازهای منحصر به فرد شهروندان جهانی موبایل و فعال دیجیتال، خانواده‌های آن‌ها و کسب‌وکارها خدمت می‌کند.',
        whoWeAreParagraph2:
            'این یک برند مدرن خدمات بانکی خصوصی بین‌المللی است که تاریخ طولانی و نگاهی بلندمدت به آینده دارد.',
        whoWeAreParagraph3:
            'قدرت بانک ما در تنوع بانکداران خصوصی بین‌المللی ما نهفته است.',
        whoWeAreParagraph4:
            'تیم ما به دوازده زبان صحبت می‌کند و از مهارت‌های خود برای خدمت به مشتریان خصوصی و نهادی استفاده می‌کند و روابط شخصی‌سازی شده و راه‌حل‌های مالی فردی را ارائه می‌دهد.',
        servicesWeProvideTitle: 'خدماتی که ما ارائه می‌دهیم',
        fastPaymentTitle: 'ما یک روش پرداخت سریع و امن هستیم',
        fastPaymentParagraph:
            'در Wall Street IBU ، ما به توانمندسازی افراد و کسبوکارها با خدمات بانکی برونمرزی استثنائی اعتقاد داریم. از سال 2022\n' +
            'تأسیس شدهایم و در صنعت مالی با شهرتی از اعتماد، صداقت و نوآوری شناخته میشویم. تیم متخصص ما متعهد است که شما را\n' +
            'در پیچیدگیهای بانکداری برونمرزی با سهولت هدایت کند',
        openAccountSectionHeading: 'WALL Street IBU',
        openAccountSectionParagraph:
            'این یک بانک خصوصی بین‌المللی است که به نیازهای منحصربه‌فرد افراد تلفن همراه و فعال دیجیتالی، خانواده‌ها و کسب‌وکارهای آنها پاسخ می‌دهد.',
        learnMoreBtn: 'بیشتر بدانید',
        openAccountBtn: 'یک حساب کاربری باز کنید',

        //  CARD TRANSLATIONS (EN) 
        cards: {
            privateBanking: {
                short: 'چ ب',
                title: 'بانکداری خصوصی',
                description:
                    "مشخصه بارز بانکداری خصوصی، ارائه خدمات شخصی و سفارشی مثالزدنی است . هیچ دو مشتری یکسان نیستند، بنابراین انعطافپذیری سنگ بنای آن است. در مورد خدمات بانکی مورد نیاز خود به ما بگویید و\n" +
                    "بانکدار خصوصی بینالمللی وال استریت بانک شما آن را اجرا خواهد کرد. حتی کارهای چالشبرانگیز هم نمیتوانند ما را سردرگم\n" +
                    "کنند ."
            },
            commercialBanking: {
                short: 'کی بی',
                title: 'بانکداری تجاری',
                description:
                    "کسبوکارها نیز میتوانند از خدمات بانکداری خصوصی بهرهمند شوند! اگر به دنبال یک شریک تجاری جهانی قابلاعتماد برای\n" +
                    "کمک به مدیریت تراکنشها و ایجاد ثروت در مرزها هستید، با بانکداران متخصص ما در زمینه تراکنشهای پرداخت پیچیده و\n" +
                    "تأمین مالی تجارت صحبت کنید"
            },
            cardServices: {
                short: 'ک',
                title: 'کارتها',
                description:
                    'در Wall Street IBU ، ما به شما این امکان را میدهیم که از هر نقطه از جهان به داراییهای خود دسترسی پیدا کرده، آنها را\n' +
                    'محافظت کنید و رشد دهید، با حساب بانکی بینالمللی در یک حوزه قضایی امن. برای دسترسی به وجوه خود در حال حرکت،\n' +
                    'کارتهای دبیت جهانی دریافت خواهید کرد که تراکنشها را بهصورت روان و بدون مشکل انجام میدهند'
            },
            digitalAssets: {
                short: 'سی آ',
                title: 'بانکداری داراییهای دیجیتال',
                description:
                    'ما خدمات بانکی جامع برای شرکتهای مستقر و استارتآپها در دنیای بلاکچین و ارزهای دیجیتال ارائه میدهیم، همچنین\n' +
                    'خدمات بانکداری خصوصی برای افراد با داراییهای بالا که در حال تجارت یا سرمایهگذاری در داراییهای دیجیتال هستند'
            },
            tradeFinance: {
                short: 'تی اف',
                title: 'تأمین مالی تجارت',
                description:
                    "به عنوان دارنده حساب شرکتی در Wall Street IBU ، شما ارتباط مستقیم با کارشناسان تأمین مالی تجارت و اعتبارات اسنادی\n" +
                    "خواهید داشت. بدین ترتیب، مشتریان ما میتوانند ابزارهای خود را از بانکهای معتبر تأسیس شده دریافت کنند، بدون آنکه مجبور\n" +
                    "به مواجهه با دشواریهای کار با مؤسسات بزرگ باشند"
            },
        },
    },
};


// Contact component
const contactPageTranslations = {
    en: {
        heroTitle1: 'Contact',
        heroTitle2: 'Us',
        heroDescription:
            'We’re here to help! Whether you have a question, need assistance, or want to explore how we can work together, our team is just a message away. Let’s connect and make things happen.',
        heading: 'Contact Us',
        paragraph:
            'You can contact us by mail or phone number. Or you can leave your contact details, and our managers will contact you.',
        representativeOfficeTitle: 'Representative Office',
     
        ourEmailTitle: 'Our Email',
        contactTitle: 'Contact',
    },
    ru: {
        heroTitle1: 'Свяжитесь',
        heroTitle2: 'с нами',
        heroDescription:
            'Мы здесь, чтобы помочь! Если у вас есть вопрос, нужна помощь или вы хотите узнать, как мы можем работать вместе, наша команда всего в одном сообщении от вас. Давайте свяжемся и сделаем это.',
        heading: 'Свяжитесь с нами',
        paragraph:
            'Вы можете связаться с нами по почте или телефону. Или вы можете оставить свои контактные данные, и наши менеджеры свяжутся с вами.',
        representativeOfficeTitle: 'Представительский офис',
        ourEmailTitle: 'Наша почта',
        contactTitle: 'Контакты',
    },
    fas: {
        heroTitle1: 'تماس',
        heroTitle2: ' با ما',
        heroDescription:
            'ما اینجا هستیم تا کمک کنیم! چه سوالی داشته باشید، به کمک نیاز داشته باشید یا بخواهید بررسی کنید که چطور میتوانیم با هم\n' +
            'همکاری کنیم، تیم ما تنها یک پیام فاصله دارد. بیایید ارتباط برقرار کنیم و کارها را پیش ببریم',
        heading: 'تماس با ما',
        paragraph:
            'برای ارتباط با ما میتوانید از طریق ایمیل یا شماره تماس زیر اقدام نمایید. همچنین در صورت تمایل، اطلاعات تماس خود را ثبت\n' +
            'کنید تا مدیران ما در اسرع وقت با شما تماس بگیرند .',
        representativeOfficeTitle: 'دفتر نمایندگی',

        ourEmailTitle: 'ایمیل',
        contactTitle: 'تلفن تماس',
    },
};


const contactUsFormTranslations = {
    en: {
        firstNameLabel: 'First Name',
        lastNameLabel: 'Last Name',
        emailLabel: 'Email',
        messageLabel: 'Message',
        placeholders: {
            firstName: 'Enter your first name',
            lastName: 'Enter your last name',
            email: 'Enter your email',
            message: 'Message'
        },
        sendButton: 'Send Message',

        validation: {
            requiredField: 'Required field',
            invalidFormat: 'Invalid format'
        }
    },
    ru: {
        firstNameLabel: 'Имя',
        lastNameLabel: 'Фамилия',
        emailLabel: 'Ваш Email',
        messageLabel: 'Сообщение',
        placeholders: {
            firstName: 'Введите ваше имя',
            lastName: 'Введите вашу фамилию',
            email: 'Введите ваш email',
            message: 'Введите ваше сообщение'
        },
        sendButton: 'Отправить сообщение',

        validation: {
            requiredField: 'Обязательное поле',
            invalidFormat: 'Неверный формат'
        }
    },
    fas: {
        firstNameLabel: 'نام',
        lastNameLabel: 'نام خانوادگی',
        emailLabel: 'ایمیل شما',
        messageLabel: 'پیام',
        placeholders: {
            firstName: 'نام خود را وارد کنید',
            lastName: 'نام خانوادگی خود را وارد کنید',
            email: 'ایمیل خود را وارد کنید',
            message: 'پیام خود را وارد کنید'
        },
        sendButton: 'ارسال پیام',

        validation: {
            requiredField: 'فیلد مورد نیاز',
            invalidFormat: 'قالب نامعتبر'
        }
    },
};

const aboutUsPageTranslations = {
    en: {
        heroTitle1: 'About',
        heroTitle2: 'Wall Street IBU',
        heroDescription:
            'Wall Street IBU is an international private bank! The Bank is legally incorporated in Fomboni, Comoros Islands, a premier offshore finance hub, and has a team of International Private Bankers working digitally around the world providing almost 24/7 service.',

        paragraph1:
            'For over two decades, our predecessors have built a reputation for confidence, reliability, and strategic partnerships. In July 2022, we embarked on a new chapter with the merger of two pillars of financial expertise: Jilin Jiutai Rural Commercial Bank Co., Ltd. , a leading Chinese commercial Bank with a deep history, and MC Financial Services Limited, a global financial force with roots in the Asia Pacific region. This union, driven by a shared vision of international growth, created Wall Street Bank to deliver a new standard of international financial services.',
        paragraph2:
            'We provide flexible financial services to individuals and businesses with an international presence. An offshore account offers flexibility, discretion and in many cases enhanced security. We offer specialized services related to digital assets, including escrow services, and financing of real estate in prime cities and resort areas worldwide.',

        yourGlobalTitle: 'Your Global Financial Partner',
        yourGlobalIntro:
            'Wall Street Bank is designed for individuals and businesses seeking flexible financial solutions in a connected world. Our offshore accounts offer:',

        unparalleledFlexibilityTitle: 'Unparalleled Flexibility:',
        unparalleledFlexibilityDesc:
            'Tailored solutions to meet your unique needs, with a focus on international opportunities.',
        enhancedPrivacyTitle: 'Enhanced Privacy & Security:',
        enhancedPrivacyDesc:
            'Protect your assets and financial information with our robust offshore framework and commitment to confidentiality.',
        strategicAdvantagesTitle: 'Strategic Advantages:',
        strategicAdvantagesDesc:
            'Benefit from a stable and secure environment, ideal for managing and growing your global wealth.',

        signUpBtn: 'Sign Up',

        specFinTitle: 'Specializing in the Future of Finance',
        paragraph3:
            'We are at the forefront of the evolving financial landscape, offering specialized services that encompass the digital age:',
        digitalAssetEscrowTitle: 'Digital Asset Escrow:',
        digitalAssetEscrowDesc:
            'Securely manage your digital assets with our robust escrow services, designed for the evolving financial landscape.',
        globalRealEstateTitle: 'Global Real Estate Financing:',
        globalRealEstateDesc:
            'Access financing for prime properties in major cities and resort destinations worldwide, making your real estate dreams a reality.',

        paragraph4:
            'Finally, Wall Street IBU works with crypto and blockchain companies to provide them with full-service multi-currency banking, asset management, trading and advisory. We are one of the very few offshore regulated financial banks that support blockchain and digital assets.',
    },

    ru: {
        heroTitle1: 'О нас',
        heroTitle2: 'Wall Street IBU',
        heroDescription:
            'Wall Street IBU — это международный частный банк! Банк юридически зарегистрирован в Фомбони, Коморские острова, ведущем оффшорном финансовом центре, и имеет команду международных частных банкиров, работающих в цифровом формате по всему миру, предоставляя услуги почти круглосуточно.',

        paragraph1:
            'На протяжении более двух десятилетий наши предшественники завоевали репутацию уверенности, надежности и стратегических партнерств. В июле 2022 года мы начали новую главу слиянием двух опор финансовой экспертизы: Jilin Jiutai Rural Commercial Bank Co., Ltd., ведущего китайского коммерческого банка с глубокой историей, и MC Financial Services Limited, глобальной финансовой силы с корнями в Азиатско-Тихоокеанском регионе. Этот союз, движимый общей целью международного роста, создал Wall Street Bank для предоставления нового стандарта международных финансовых услуг.',
        paragraph2:
            'Мы предоставляем гибкие финансовые услуги для физических и юридических лиц с международным присутствием. Оффшорный счет предлагает гибкость, конфиденциальность и во многих случаях повышенную безопасность. Мы предлагаем специализированные услуги, связанные с цифровыми активами, включая эскроу-услуги и финансирование недвижимости в крупных городах и курортных зонах по всему миру.',

        yourGlobalTitle: 'Ваш глобальный финансовый партнер',
        yourGlobalIntro:
            'Банк Уолл-Стрит создан для физических лиц и бизнеса, ищущих гибкие финансовые решения в связанном мире. Наши офшорные счета предлагают:',

        unparalleledFlexibilityTitle: 'Непревзойденная гибкость:',
        unparalleledFlexibilityDesc:
            'индивидуальные решения для удовлетворения ваших уникальных потребностей с акцентом на международные возможности.',
        enhancedPrivacyTitle: 'Повышенная конфиденциальность и безопасность: ',
        enhancedPrivacyDesc:
            'защитите свои активы и финансовую информацию с помощью нашей надежной офшорной структуры и обязательства по соблюдению конфиденциальности.',
        strategicAdvantagesTitle: 'Стратегические преимущества: ',
        strategicAdvantagesDesc:
            ' воспользуйтесь стабильной и безопасной средой, идеальной для управления и увеличения вашего глобального богатства.',

        signUpBtn: 'Зарегистрироваться',

        specFinTitle: 'Специализация на будущем финансов',
        paragraph3:
            'Мы находимся на переднем крае развивающегося финансового ландшафта, предлагая специализированные услуги, охватывающие цифровую эпоху:',
        digitalAssetEscrowTitle: 'Эскроу цифровых активов:',
        digitalAssetEscrowDesc:
            'надежно управляйте своими цифровыми активами с помощью наших надежных эскроу-услуг, разработанных для развивающегося финансового ландшафта.',
        globalRealEstateTitle: 'Глобальное финансирование недвижимости:',
        globalRealEstateDesc:
            'получите финансирование для первоклассных объектов в крупных городах и курортных направлениях по всему миру, осуществляя свои мечты о недвижимости.',

        paragraph4:
            "Наконец, Wall Street IBU работает с крипто- и блокчейн-компаниями, предоставляя им полный спектр услуг многовалютного банкинга, управления активами, торговли и консультаций. Мы одни из немногих офшорных регулируемых финансовых банков, которые поддерживают блокчейн и цифровые активы."
    },

    fas: {
        heroTitle1: 'درباره',
        heroTitle2: 'Wall Street IBU',
        heroDescription:
            "یک بانک خصوصی بینالمللی است که بهطور قانونی در فومبونی، جزایر کومور — یکی از مراکز معتبر\n" +
            "مالی برونمرزی — به ثبت رسیده است. این بانک با تیمی از بانکداران خصوصی بینالمللی، بهصورت دیجیتالی و تقریبا 2۴\n" +
            "ساعته در سطح جهان فعالیت میکند و خدمات حرفهای و اختصاصی ارائه میدهد",
        paragraph1:
            "بیش از دو دهه، پیشینیان ما بنیانگذار اعتبار، اعتماد و همکاریهای راهبردی بودهاند. در ژوئیه 2022 ، فصل تازهای آغاز شد؛ با\n" +
            "ادغام دو نهاد برجسته مالی — بانک تجاری روستایی جیلین جیوتای )از چین( و شرکت خدمات مالی MC ( با ریشهای در منطقه\n" +
            "آسیا-اقیانوسیه ) — Wall Street Bank شکل گرفت تا استانداردی نوین در خدمات مالی بینالمللی تعریف کند . ما خدمات مالی منعطف برای افراد و کسبوکارهای دارای حضور بینالمللی ارائه میدهیم. حسابهای بانکی برونمرزی،\n",
        paragraph2:
            "انعطافپذیری، محرمانگی و در بسیاری موارد امنیت بالاتری را فراهم میکنند. از جمله خدمات تخصصی ما میتوان به\n" +
            "داراییهای دیجیتال، خدمات حساب امانی (Escrow) و تأمین مالی املاک در شهرهای بزرگ و مناطق توریستی مطرح جهان\n" +
            "اشاره کرد",
        yourGlobalTitle: 'شریک مالی جهانی شما',
        yourGlobalIntro:
            "برای افرادی و کسبوکارهایی طراحی شده است که در دنیای بههمپیوسته امروز بهدنبال راهحلهای مالی\n" +
            "انعطافپذیر هستند. حسابهای بانکی برونمرزی ما مزایای زیر را ارائه میدهند",
        unparalleledFlexibilityTitle: ' انعطافپذیری بینظیر:',
        unparalleledFlexibilityDesc:
            'راهحلهایی متناسب با نیازهای خاص شما، با تمرکز بر فرصتهای بینالمللی . حفظ حریم.',
        enhancedPrivacyTitle: 'خصوصی و امنیت :',
        enhancedPrivacyDesc:
            'محافظت از داراییها و اطلاعات مالی شما در چارچوبی قوی و متعهد به محرمانگی .',
        strategicAdvantagesTitle: 'مزایای راهبردی:',
        strategicAdvantagesDesc:
            'بهرهمندی از محیطی باثبات و امن، ایدهآل برای مدیریت و رشد ثروت جهانی شما .',

        signUpBtn: 'ثبت نام کنید',

        specFinTitle: 'متخصص در آینده مالی',
        paragraph3:
            'ما در خط مقدم تغییرات چشمانداز مالی قرار داریم و خدمات تخصصیای را ارائه میدهیم که با نیازهای دوران دیجیتال همراستا است:',
        digitalAssetEscrowTitle: 'حساب امانی داراییهای دیجیتال:',
        digitalAssetEscrowDesc:
            'مدیریت امن داراییهای دیجیتال شما با خدمات حساب امانی قدرتمند، طراحیشده برای فضای مالی در حال تحول .',
        globalRealEstateTitle: 'تأمین مالی املاک جهانی:',
        globalRealEstateDesc:
            'دسترسی به تأمین مالی برای خرید املاک برجسته در شهرهای مهم و مقاصد تفریحی سراسر جهان، تا بتوانید رؤیاهای املاک خود را به واقعیت تبدیل کنید',

        paragraph4:
            'در نهایت، Wall Street IBU با شرکتهای کریپتو و بلاکچین همکاری میکند تا خدمات بانکداری چند ارزی، مدیریت دارایی، معاملات و مشاوره کامل را به آنها ارائه دهد. ما یکی از معدود بانکهای مالی برونمرزی تحت نظارت هستیم که از بلاکچین و داراییهای دیجیتال پشتیبانی میکند',
    },
};

// privateBankingPage Translations
const privateBankingTranslations = {
    en: {
        heroTitle1: "Private",
        heroTitle2: "Banking",
        heroDescription:
            "Wall Street IBU is an international private bank! The Bank is incorporated in Fomboni, Comoros Islands, and has a team of International Private Bankers working digitally around the world providing almost 24/7 service.",
        paragraph1: {
            part1:
                "The hallmark of Private Banking is exemplary personal, bespoke service. No two clients are the same, so flexibility is a cornerstone. Tell us about the banking service you need, and your Wall Street IBU International Private Banker will put it in place.",
            bold: "Not even challenging tasks can fluster us."
        },
        paragraph2:
            "We have a long history of financial stability, working with complex, multi-jurisdictional entities, individuals, and families to protect and enhance wealth. Our personal approach to preserving and growing your wealth starts with our core focus of accounts featuring above average returns, hedging market risk volatility. We achieve this by making only highly selective loans, secured against liquid assets and prime real estate in major cities worldwide. We offer accounts to those who need an international presence. An overseas current or savings account provides flexibility, discretion and in many cases enhanced security and confidentiality.",
        paragraph3:
            "We can boast outstanding specialist expertise in the field of digital assets and blockchain banking, in the development of fund solutions, in tokenization, in the setting up of capital market issues – and, of course, also in conventional banking. We also provide a wealth of expertise in the field of HNWI mortgages.",
        servicesListBlockTitle:
            "We offer the following core private banking services, delivered through a secure and cutting edge digital channel:",
        serviceList: {
            left: {
                line1:
                    "Multi-currency deposit account supporting all major and some exotic currencies plus crypto currencies",
                line2: "Custody of digital assets and execution services",
                line3: "Trading and brokerage",
                line4: "Bespoke investment solutions",
                line5:
                    "Foreign Exchange – spot, forward, swap and lending"
            },
            right: {
                line1: "OTC and Derivatives Instruments",
                line2:
                    "Precious Metals Trading, Custody and Lending",
                line3:
                    "Payments, Transfers, and Credit Cards",
                line4:
                    "Lombard loans and mortgages secured by digital assets, securities and cash balances",
                line5: "Concierge services"
            }
        },
        gradientTitle:
            "The Private Banking relationship is based on a hub Multi-Currency Account (MCA) The Wall Street Ibu Multi-Currency Account offers international clients the ultimate convenience with their foreign currency transactions. Your MCA will enable you to:",
        gradientLeft: {
            line1:
                "Consolidate and manage foreign receivables and payments more efficiently",
            line2:
                "Send and receive wire payments and settle your credit card bills without currency conversion",
            line3:
                "Conduct transactions in most major world currencies."
        },
        gradientRight: {
            line1:
                "Allow for currency diversification as an investment option including our “Invest Loan” program",
            line2:
                "View balances and activities for all currency accounts online."
        },
        gradientFooter:
            "All clients will be allocated a private banker so they know immediately who to contact whenever any banking services are needed. Our private bankers speak most global languages. You can initiate the account opening process online, or schedule a call with one of our International Private Banking team today!"
    },
    ru: {
        heroTitle1: "Частное",
        heroTitle2: "банковское обслуживание",
        heroDescription:
            "Wall Street IBU — это международный частный банк! Банк зарегистрирован в Фомбони, Коморские острова, и у нас есть команда международных частных банкиров, работающих в цифровом формате по всему миру, предоставляющих услуги почти круглосуточно.",
        paragraph1: {
            part1:
                "Отличительной чертой частного банковского обслуживания является образцовый персонализированный сервис. Нет двух одинаковых клиентов, поэтому гибкость является краеугольным камнем. Расскажите нам о банковских услугах, которые вам нужны, и ваш международный частный банкир Wall Street IBU организует их.",
            bold: "Даже самые сложные задачи не могут нас смутить."
        },
        paragraph2:
            "У нас долгая история финансовой стабильности, работы с комплексными многоюрисдикционными структурами, физическими лицами и семьями для защиты и увеличения благосостояния. Наш персонализированный подход к сохранению и приумножению вашего капитала начинается с нашего основного фокуса на счетах с выше среднего доходом, хеджирующих волатильность рыночных рисков. Мы достигаем этого, предоставляя только высокоизбирательные кредиты, обеспеченные ликвидными активами и первичной недвижимостью в крупных городах мира. Мы предлагаем счета тем, кто нуждается в международном присутствии. Зарубежный текущий или сберегательный счет обеспечивает гибкость, конфиденциальность и во многих случаях повышенную безопасность.",
        paragraph3:
            "Мы можем похвастаться выдающейся специализированной экспертизой в области цифровых активов и блокчейн-банкинга, в разработке фондовых решений, в токенизации, в организации выпусков на капитальном рынке — и, конечно, также в традиционном банковском обслуживании. Мы также предоставляем богатый опыт в области ипотечного кредитования для состоятельных клиентов.",
        servicesListBlockTitle:
            "Мы предлагаем следующие основные услуги частного банковского обслуживания, предоставляемые через безопасный и современный цифровой канал:",
        serviceList: {
            left: {
                line1:
                    "Мультивалютный депозитный счет, поддерживающий все основные и некоторые экзотические валюты, а также криптовалюты",
                line2: "Кастодиальные услуги для цифровых активов и услуги по исполнению сделок",
                line3: "Торговля и брокерские услуги",
                line4: "Индивидуальные инвестиционные решения",
                line5:
                    "Валютный рынок – спот, форвард, своп и кредитование"
            },
            right: {
                line1: "Внебиржевые и производные инструменты",
                line2:
                    "Торговля драгоценными металлами, кастодиальные услуги и кредитование",
                line3:
                    "Платежи, переводы и кредитные карты",
                line4:
                    "Ломбардные кредиты и ипотеки, обеспеченные цифровыми активами, ценными бумагами и денежными средствами",
                line5: "Консьерж-услуги"
            }
        },
        gradientTitle:
            "Отношения в области частного банковского обслуживания основаны на мультивалютном счете (MCA) хаба. Мультивалютный счет Wall Street IBU предлагает международным клиентам максимальное удобство при проведении операций с иностранной валютой. Ваш MCA позволит вам:",
        gradientLeft: {
            line1:
                "Консолидировать и управлять иностранными дебиторскими и кредиторскими платежами более эффективно.",
            line2:
                "Отправлять и получать денежные переводы и оплачивать счета по кредитным картам без конверсии валюты.",
            line3:
                "Проводить операции в большинстве основных мировых валют."
        },
        gradientRight: {
            line1:
                "Обеспечить диверсификацию валют как инвестиционную опцию, включая нашу программу «Инвестиционный кредит».",
            line2:
                "Просматривать балансы и операции по всем валютным счетам онлайн."
        },
        gradientFooter:
            "Каждому клиенту будет назначен персональный банкир, чтобы он сразу знал, к кому обратиться, когда понадобятся банковские услуги. Наши персональные банкиры говорят на большинстве мировых языков. Вы можете начать процесс открытия счета онлайн или запланировать звонок с одним из членов нашей команды международного частного банковского обслуживания уже сегодня!"
    },
    fas: {
        heroTitle1: "بانکداری",
        heroTitle2: "خصوصی",
        heroDescription:
            "یک بانک خصوصی بینالمللی است که در فومبونی، جزایر کومور به ثبت رسیده و تیمی از بانکداران خصوصی بینالمللی دارد که بهصورت دیجیتالی در سراسر جهان فعالیت میکنند و تقریبا 2۴ ساعت شبانهروز خدمات ارائه میدهند",
        paragraph1: {
            part1:
                "ویژگی بارز بانکداری خصوصی، ارائه خدمات شخصی و سفارشی است. هیچ دو مشتری یکسان نیستند، بنابراین انعطافپذیری جزء اصول اساسی ماست. در مورد خدمات بانکی مورد نیاز خود با ما صحبت کنید و بانکدار خصوصی شما در Wall Street IBU آن را اجرا خواهد کرد.",
            bold: "حتی وظایف چالشبرانگیز نیز نمیتواند ما را گیج کند ."
        },
        paragraph2:
            "ما تاریخچه طولانیای از ثبات مالی داریم و با نهادهای پیچیده و افراد و خانوادهها برای حفاظت و افزایش ثروت همکاری میکنیم. روش شخصی ما برای حفظ و رشد ثروت شما با تمرکز بر حسابهایی با بازدهی بالاتر و کاهش نوسانات ریسک بازار شروع میشود. این هدف را با اعطای وامهای انتخابی، تضمینشده توسط داراییهای نقدی و املاک برجسته درشهرهای مهم جهانی، محقق میکنیم. ما حسابهایی برای کسانی که به حضور بینالمللی نیاز دارند، ارائه میدهیم.",
        paragraph3:
            "حساب جاری یا پسانداز برونمرزی انعطافپذیری، محرمانگی و در بسیاری از موارد امنیت و محرمانگی بالاتری فراهم میآورد . ما همچنین تخصص برجستهای در زمینه داراییهای دیجیتال و بانکداری بلاکچین، توسعه راهحلهای سرمایهگذاری، توکنیزاسیون، ایجاد مسائل بازار سرمایه و البته بانکداری سنتی داریم. همچنین در زمینه وامهای مسکن برای افراد با ثروت بالا (HNWI)تجربه و تخصص فراوانی داریم .",
        servicesListBlockTitle:
            "ما خدمات اصلی بانکداری خصوصی زیر را از طریق یک کانال دیجیتال امن و پیشرفته ارائه میدهیم:",
        serviceList: {
            left: {
                line1:
                    "حساب سپرده چند ارزی با پشتیبانی از ارزهای اصلی و برخی ارزهای خاص، به علاوه ارزهای دیجیتال",
                line2: "نگهداری داراییهای دیجیتال و خدمات اجرایی",
                line3: "معاملات و کارگزاری",
                line4: "راهحلهای سرمایهگذاری سفارشی",
                line5:
                    "معاملات ارزی – اسپات، فوروارد، سواپ و وامدهی"
            },
            right: {
                line1: "ابزارهای OTC و مشتقات",
                line2:
                    "معاملات فلزات گرانبها، نگهداری و وامدهی",
                line3:
                    "پرداختها، انتقالها و کارتهای اعتباری",
                line4:
                    "وامها و وامهای مسکن لوامباری با ضمانت داراییهای دیجیتال، اوراق بهادار و موجودی نقدی",
                line5: "خدمات ویژه شخصی"
            }
        },
        gradientTitle:
            "ارتباط بانکداری خصوصی بر اساس حساب چند ارزی (MCA) است . حساب چند ارزی Wall Street IBU راحتی کامل را برای مشتریان بینالمللی در تراکنشهای ارزی فراهم میآورد. حساب",
        gradientLeft: {
            line1:
                "دریافتها و پرداختهای ارزی را بهطور مؤثر مدیریت کنید",
            line2:
                "پرداختهای سیمی ارسال و دریافت کنید و قبوض کارت اعتباری خود را بدون نیاز به تبدیل ارز تسویه کنید",
            line3:
                "تراکنشها را در اکثر ارزهای اصلی جهان انجام دهید"
        },
        gradientRight: {
            line1:
                "امکان تنوع ارزی را بهعنوان یک گزینه سرمایهگذاری شامل برنامه “Invest Loan” داشته باشید",
            line2:
                "موجودی و فعالیتهای تمامی حسابهای ارزی خود را بهصورت آنلاین مشاهده کنید"
        },
        gradientFooter:
            "تمامی مشتریان یک بانکدار خصوصی اختصاصی خواهند داشت تا بدانند که در صورت نیاز به هرگونه خدمات بانکی، به چه کسی مراجعه کنند. بانکداران خصوصی ما به اکثر زبانهای جهانی تسلط دارند. شما میتوانید فرآیند افتتاح حساب را آنلاین آغاز کنید یا برای هماهنگی با یکی از اعضای تیم بانکداری خصوصی بینالمللی ما، تماس بگیرید"
    },
};

const commercialBankingTranslations = {
    en: {
        hero: {
            title_1: "Commercial",
            title_2: "Banking",
            description: "Wall Street IBU is an international private bank! The Bank is incorporated in Fomboni, Comoros Islands, and has a team of International Private Bankers working digitally around the world providing almost 24/7 service."
        },
        commercial_block_desc: {
            paragraph1: "Businesses can also benefit from the private banking touch! Our International Commercial Banking services are designed for enterprises that are run by globally mobile families. If you are looking for a reliable global trade partner to help you handle transactions and create wealth across borders, talk to our expert bankers in the areas of complex payment transactions and trade finance. With our international expertise and network, we are a valued partner when it comes to accurately assessing markets and managing risks.",
            paragraph2: "As a bank we are a specialist in niche and emerging markets. We provide customized solutions to multi-jurisdictional entities, individuals, and families to protect and enhance wealth. We enable them to execute business transactions across the globe in a secure, efficient and transparent manner. As a trusted partner for modern offshore banking, our solutions are based on the latest and secure technological platforms. We support your global success and ensure your international transactions reach their destination at all times.",
            paragraph3: "Our Commercial Banking division is ideal for complex, multi-jurisdictional businesses who are often “derisked” by large international banks. We are (almost) always able to find a regulation-compliant solution. We can boast outstanding specialist expertise in the field of digital assets and blockchain banking, in the development of fund solutions, in tokenization, in the setting up of capital market issues – and, of course, also in conventional commercial banking. We also provide a wealth of expertise in the field of HNWI mortgages, for example with personal loans secured by a charge over company assets."
        },
        services_list_block: {
            title: "Our Corporate Multi-Currency Account (MCA) is our flagship product for international companies. Our External Asset Managers Desk works closely with financial professionals and fiduciaries. Your MCA will enable you to:",
            left: {
                line1: "Conduct transactions in most major world currencies",
                line2: "Consolidate and manage foreign receivables and payments more efficiently",
                line3: "Send and receive wire payments and settle your credit card bills without currency conversion"
            },
            right: {
                line1: "View balances and activities for all currency accounts online",
                line2: "Allow for currency diversification as an investment option including our “Invest Loan” program"
            }
        },
        gradient: {
            title: "Non-resident companies, trusts, protected cell companies and the like can all benefit the following core private banking services, delivered through a secure and cutting edge digital channel:",
            left: {
                line1: "Multi-currency deposit account supporting all major and some exotic currencies plus crypto currencies. Professional management of your payment transactions by an experienced back-office team",
                line2: "Compliance-integrated process for a secure and punctual payment",
                line3: "Segregated sub-accounts for projects or client funds",
                line4: "Custody of digital assets and execution services",
                line5: "Trading and brokerage",
                line6: "Bespoke investment solutions"
            },
            right: {
                line1: "Foreign Exchange – spot, forward, swap and lending",
                line2: "OTC and Derivatives Instruments",
                line3: "Precious Metals Trading, Custody and Lending",
                line4: "Payments, Transfers, and Credit Cards",
                line5: "Lombard loans and mortgages secured by digital assets, securities and cash balances",
                line6: "Business Concierge services"
            },
            footer: "All clients will be allocated a private banker so they know immediately who to contact whenever any banking services are needed. Our private bankers speak most global languages. You can initiate the account opening process online, or find out more about our Transaction Banking/Commercial Banking offer by booking an online appointment with our International Commercial Banking team today!"
        }
    },
    ru: {
        hero: {
            title_1: "Коммерческий",
            title_2: "банкинг",
            description: "Wall Street IBU — это международный частный банк! Банк зарегистрирован в Фомбони, Коморские острова, и имеет команду международных частных банкиров, работающих в цифровом формате по всему миру, предоставляя услуги почти круглосуточно."
        },
        commercial_block_desc: {
            paragraph1: "Бизнес также может воспользоваться преимуществами частного банковского обслуживания! Наши международные коммерческие банковские услуги предназначены для предприятий, управляемых глобально мобильными семьями. Если вы ищете надежного глобального торгового партнера, который поможет вам осуществлять транзакции и создавать богатство через границы, поговорите с нашими экспертами-банкирами в области сложных платежных транзакций и торгового финансирования. Благодаря нашему международному опыту и сети мы являемся ценным партнером в точной оценке рынков и управлении рисками.",
            paragraph2:
                "Как банк, мы являемся специалистами в нишевых и развивающихся рынках. Мы предоставляем индивидуальные решения многоюрисдикционным организациям, частным лицам и семьям для защиты и увеличения богатства. Мы помогаем им осуществлять бизнес-транзакции по всему миру безопасным, эффективным и прозрачным образом. Как надежный партнер для современного оффшорного банковского обслуживания, наши решения основаны на последних и безопасных технологических платформах. Мы поддерживаем ваш глобальный успех и гарантируем, что ваши международные транзакции всегда достигают своей цели.",
            paragraph3:
                "Наше подразделение коммерческого банковского дела идеально подходит для сложных многоюрисдикционных бизнесов, которые часто «снижаются в рисках» крупными международными банками. Мы (почти) всегда можем найти решение, соответствующее требованиям регулирования. Мы можем похвастаться выдающейся специализированной экспертизой в области цифровых активов и блокчейн-банкинга, в разработке фондовых решений, в токенизации, в организации вопросов капитального рынка — и, конечно, также в традиционном коммерческом банковском деле. Мы также предоставляем богатый опыт в области ипотечного кредитования для состоятельных клиентов, например, с личными займами, обеспеченными залогом активов компании.",
        },
        services_list_block: {
            title:
                "Наш корпоративный мультивалютный счет (MCA) — это наш флагманский продукт для международных компаний. Наш стол внешних управляющих активами тесно сотрудничает с финансовыми профессионалами и доверительными управляющими. Ваш MCA позволит вам:",
            left: {
                line1: "Осуществлять транзакции в большинстве основных мировых валют",
                line2: "Консолидировать и управлять иностранными дебиторскими и кредиторскими задолженностями более эффективно",
                line3: "Отправлять и получать платежи по проводам и погашать счета кредитных карт без конвертации валюты"
            },
            right: {
                line1: "Просматривать балансы и операции по всем валютным счетам онлайн",
                line2: "Позволять диверсификацию валют как инвестиционную опцию, включая нашу программу «Инвест-кредит»"
            }
        },
        gradient: {
            title: "Нерезидентные компании, трасты, защищенные ячейковые компании и подобные могут воспользоваться следующими основными услугами частного банковского обслуживания, предоставляемыми через безопасный и современный цифровой канал:",
            left: {
                line1: "Мультивалютный депозитный счет, поддерживающий все основные и некоторые экзотические валюты, а также криптовалюты. Профессиональное управление вашими платежными транзакциями опытной командой бэк-офиса",
                line2: "Процесс, интегрированный с соблюдением норм, для безопасного и своевременного платежа",
                line3: "Сегрегированные субсчета для проектов или клиентских средств",
                line4: "Хранение цифровых активов и услуги по исполнению",
                line5: "Торговля и брокерские услуги",
                line6: "Индивидуальные инвестиционные решения"
            },
            right: {
                line1: "Валютный рынок — спот, форвард, своп и кредитование",
                line2: "Инструменты OTC и деривативы",
                line3: "Торговля драгоценными металлами, хранение и кредитование",
                line4: "Платежи, переводы и кредитные карты",
                line5: "Ломбардные кредиты и ипотеки, обеспеченные цифровыми активами, ценными бумагами и денежными средствами",
                line6: "Услуги бизнес-консьержа"
            },
            footer: "Каждому клиенту будет назначен личный банкир, чтобы они сразу знали, к кому обратиться, когда понадобятся банковские услуги. Наши личные банкиры говорят на большинстве мировых языков. Вы можете начать процесс открытия счета онлайн или узнать больше о нашем предложении по транзакционному банковскому обслуживанию/коммерческому банковскому обслуживанию, записавшись на онлайн-встречу с нашей командой международного коммерческого банковского дела уже сегодня!"
        }
    },
    fas: {
        hero: {
            title_1: "بانکداری",
            title_2: "تجاری",
            description: "یک بانک خصوصی بینالمللی است که در فومبونی، جزایر کومور ثبت شده و تیمی از بانکداران خصوصی بینالمللی دارد که بهصورت دیجیتالی در سراسر جهان فعالیت میکنند و تقریبا بهصورت 2۴ ساعته خدمات ارائه میدهند ."
        },
        commercial_block_desc: {
            paragraph1: "کسبوکارها نیز میتوانند از خدمات بانکداری خصوصی بهرهمند شوند! خدمات بانکداری تجاری بینالمللی ما برای شرکتهایی طراحی شدهاند که توسط خانوادههای با تحرک جهانی مدیریت میشوند. اگر به دنبال یک شریک تجاری جهانی قابل اعتماد برای کمک به انجام تراکنشها و ایجاد ثروت در مرزها هستید، با بانکداران متخصص ما در زمینههای تراکنشهای پرداخت پیچیده و تأمین مالی تجارت صحبت کنید. با استفاده از تخصص و شبکه بینالمللی خود، ما شریک قابل اعتمادی در ارزیابی دقیق بازارها و مدیریت ریسکها هستیم . ما بهعنوان یک بانک، در بازارهای خاص و نوظهور متخصص هستیم. ما راهحلهای سفارشی برای نهادهای چند حوزه قضائی، افراد و خانوادهها ارائه میدهیم تا ثروت خود را حفظ و افزایش دهند.",
            paragraph2: "ما این امکان را فراهم میآوریم که آنها تراکنشهای تجاری را در سطح جهانی بهصورت امن، کارآمد و شفاف انجام دهند. بهعنوان یک شریک قابل اعتماد برای بانکداری مدرن برونمرزی، راهحلهای ما بر اساس آخرین و امنترین پلتفرمهای تکنولوژیکی است. ما از موفقیت جهانی شما پشتیبانی کرده و اطمینان حاصل میکنیم که تراکنشهای بینالمللی شما در هر زمانی به مقصد خود برسند .",
            paragraph3: "بخش بانکداری تجاری ما برای کسبوکارهای پیچیده و چند حوزه قضائی که اغلب توسط بانکهای بزرگ بینالمللی از ریسکهای آنها کاسته میشود، ایدهآل است. ما )تقریبا(ً همیشه قادر به یافتن راهحلهای مطابق با مقررات هستیم. ما همچنین تخصص برجستهای در زمینه داراییهای دیجیتال و بانکداری بلاکچین، توسعه راهحلهای صندوقی، توکنیزاسیون، راهاندازی مسائل بازار سرمایه – و البته، بانکداری تجاری سنتی داریم. ما همچنین در زمینه وامهای مسکن برای افراد با ثروت بالا (HNWI) ، بهویژه وامهای شخصی که با تضمین داراییهای شرکت ارائه میشود، تخصص داریم"
        },
        services_list_block: {
            title: "حساب چند ارزی شرکتی (MCA) محصول پرچمدار ما برای شرکتهای بینالمللی است. میز مدیریت داراییهای خارجی ما بهطور نزدیک با حرفهایهای مالی و امانتداران همکاری میکند. حساب MCA شما این امکان را میدهد که:",
            left: {
                line1: "تراکنشها را در بیشتر ارزهای اصلی دنیا انجام دهید .",
                line2: "دریافتها و پرداختهای ارزی را مؤثرتر مدیریت کنید",
                line3: "پرداختهای سیمی ارسال و دریافت کنید و قبوض کارت اعتباری خود را بدون تبدیل ارز تسویه کنید ."
            },
            right: {
                line1: "موجودی و فعالیتهای تمامی حسابهای ارزی را آنلاین مشاهده کنید",
                line2: "امکان تنوع ارزی بهعنوان یک گزینه سرمایهگذاری، از جمله برنامه “Invest Loan” را فراهم میآورد ."
            }
        },
        gradient: {
            title: "شرکتهای غیرمقیم، تراستها، شرکتهای سلولی محافظتشده و مشابه آنها میتوانند از خدمات بانکداری خصوصی اصلی زیر بهرهمند شوند که از طریق یک کانال دیجیتال امن و پیشرفته ارائه میشود :",
            left: {
                line1: "حساب سپرده چند ارزی با پشتیبانی از تمام ارزهای اصلی و برخی ارزهای خاص، همراه با ارزهای دیجیتال",
                line2: "مدیریت حرفهای تراکنشهای پرداخت شما توسط تیم پشتیبانی مجرب",
                line3: "فرآیند همراستای مقررات برای پرداختهای امن و به موقع",
                line4: "حسابهای فرعی مجزا برای پروژهها یا وجوه مشتری",
                line5: "خدمات نگهداری داراییهای دیجیتال و اجرای تراکنشها",
                line6: "خدمات تجارت، کارگزاری و راهحلهای سرمایهگذاری سفارشی"
            },
            right: {
                line1: "خدمات ویژه مشاور کسبوکار",
                line2: "تجارت ارز خارجی – نقدی، آتی، سواپ و وامدهی",
                line3: "ابزارهای OTC و مشتقات",
                line4: "تجارت فلزات گرانبها، نگهداری و وامدهی",
                line5: "پرداختها، انتقالها و کارتهای اعتباری",
                line6: "وامهای لومبارد و وامهای مسکن تأمینشده توسط داراییهای دیجیتال، اوراق بهادار و موجودیهای نقدی"
            },
            footer: "تمامی مشتریان یک بانکدار خصوصی اختصاصی خواهند داشت تا بدانند که در هر زمان که نیاز به خدمات بانکی داشته باشند، با چه کسی تماس بگیرند. بانکداران خصوصی ما به بیشتر زبانهای جهانی مسلط هستند. شما میتوانید فرایند افتتاح حساب را بهصورت آنلاین آغاز کنید یا برای کسب اطلاعات بیشتر در مورد خدمات بانکداری تجاری ما، قرار ملاقات آنلاین با تیم بانکداری بینالمللی تجاری ما ترتیب دهید !"
        }
    },
};

const cardsTranslations = {
    en: {
        hero: {
            title: "Cards",
            description: "Not long ago, it wasn’t all that unusual to have to carry large amounts of cash when traveling. Today, we can conveniently pull out a debit or credit card or a mobile device and settle the bill electronically there and then. It is difficult now to imagine a time when these card-based payment options were not available."
        },
        block1: {
            paragraph1: "Our customers using debit and credit cards enjoy the convenience that these cards bring in, for improved financial management.",
            paragraph2: "In the background, Wall Street IBU also works with partners internationally and payment service providers and is primarily responsible for cash management, the coordination of data and payment flows and for all licensing and compliance tasks, adding the security of a regulated offshore bank as a party to the transactions.",
            imageAlt: "card_block Description"
        },
        block2: {
            paragraph1: "At Wall Street IBU we allow you to protect, access and grow your wealth from anywhere in the world with an international bank account in a safe jurisdiction.",
            paragraph2: "To access your funds on the move, you will receive one or more global debit cards for seamless transactions."
        },
        button: {
            title: "Sign Up"
        },
        block3: {
            paragraph1: "Our customers using debit and credit cards enjoy the convenience that these cards bring in, for improved financial management.",
            paragraph2: "In the background, Wall Street IBU also works with partners internationally and payment service providers and is primarily responsible for cash management, the coordination of data and payment flows and for all licensing and compliance tasks, adding the security of a regulated offshore bank as a party to the transactions.",
            imageAlt: "card_block Description"
        }
    },
    ru: {
        hero: {
            title: "Карты",
            description:
                "Совсем недавно было довольно обычным носить с собой большие суммы наличных при путешествиях. Сегодня мы можем удобно достать дебетовую или кредитную карту или мобильное устройство и оплатить счет электронно прямо на месте. Теперь трудно представить время, когда эти варианты оплаты картами не были доступны."
        },
        block1: {
            paragraph1:
                "Наши клиенты, использующие дебетовые и кредитные карты, наслаждаются удобством, которое эти карты приносят для улучшения финансового управления.",
            paragraph2:
                "В фоновом режиме Wall Street IBU также работает с партнерами по всему миру и поставщиками платежных услуг и в первую очередь отвечает за управление наличными, координацию данных и потоков платежей, а также за все лицензирование и задачи соблюдения, добавляя безопасность регулируемого оффшорного банка как стороны в транзакциях.",
            imageAlt: "Описание карточного блока"
        },
        block2: {
            paragraph1:
                "В Wall Street IBU мы позволяем вам защищать, получать доступ и приумножать ваше состояние из любой точки мира с международным банковским счетом в безопасной юрисдикции.",
            paragraph2:
                "Чтобы получить доступ к вашим средствам в пути, вы получите одну или несколько глобальных дебетовых карт для бесшовных транзакций."
        },
        button: {
            title: "Зарегистрироваться"
        },
        block3: {
            paragraph1:
                "Банк может организовать доставку активированных POS-терминалов нашим держателям коммерческих счетов как для онлайн, так и для оффлайн использования.",
            paragraph2:
                " Из-за рисков и затрат, связанных с предоставлением услуги POS, коммерческие клиенты должны внести депозит не менее 100,000 EUR/USD/GBP, чтобы подать заявку на эту услугу.",
            imageAlt: "Описание карточного блока"
        }
    },
    fas: {
        hero: {
            title: "کارتها",
            description: 
                "مدتی پیش، داشتن مقادیر زیادی پول نقد هنگام سفر امری رایج بود. امروزه میتوانیم به راحتی کارت دبیت یا اعتباری خود یا دستگاه موبایل را بیرون بیاوریم و بهصورت الکترونیکی صورتحساب را تسویه کنیم. اکنون تصور اینکه زمانی این گزینههای پرداخت مبتنی بر کارت در دسترس نبودهاند، دشوار است"
        },
        block1: {
            paragraph1: "مشتریان ما که از کارتهای دبیت و اعتباری استفاده میکنند، از راحتی این کارتها برای مدیریت مالی بهتر بهرهمند میشوند.",
            paragraph2: "در پسزمینه، وال استریت IBU با شرکای بینالمللی و تأمینکنندگان خدمات پرداخت همکاری میکند و مسئولیت مدیریت نقدینگی، هماهنگی دادهها و جریانهای پرداخت، و همچنین انجام تمام وظایف مربوط به مجوزها و انطباق را بر عهده دارد. این کار باعث میشود تا امنیت یک بانک آفشور تحت نظارت به تراکنشها افزوده شود.",
            imageAlt: "card_block Description"
        },
        block2: {
            paragraph1: "در وال استریت IBU ، به شما این امکان را میدهیم که از هر نقطهای از دنیا به داراییهای خود دسترسی پیدا کرده، آنها را محافظت کرده و رشد دهید، از طریق یک حساب بانکی بینالمللی در یک حوزه قضائی امن.",
            paragraph2: "برای دسترسی به وجوه خود در حین حرکت، یک یا چند کارت دبیت جهانی دریافت خواهید کرد تا تراکنشها بهصورت روان و بیدردسر انجام شوند"
        },
        button: {
            title: "ثبت نام"
        },
        block3: {
            paragraph1: "مشتریان ما که از کارتهای دبیت و اعتباری استفاده میکنند، از راحتی و مدیریت مالی بهبود یافتهای که این کارتها فراهم میآورند، بهرهمند میشوند.",
            paragraph2: "در پسزمینه، وال استریت IBU با شرکای بینالمللی و تأمینکنندگان خدمات پرداخت همکاری میکند و مسئولیت مدیریت نقدینگی، هماهنگی دادهها و جریانهای پرداخت، و انجام وظایف مربوط به مجوزها و انطباق را بر عهده دارد، که به امنیت تراکنشها توسط یک بانک آفشور تحت نظارت میافزاید",
            imageAlt: "card_block Description"
        }
    }
};

const digitalAssetsBankingTranslations = {
    en: {
        hero: {
            title_1: "Digital Assets",
            title_2: "Banking",
            description: "Digital assets are part of our DNA, just like the personal contact with our clients. We are the leading bank for combining crossover between the crypto world and the securely regulated offshore banking environment."
        },
        coins_block: {
            description: "We provide comprehensive banking services for both established and startup companies from the blockchain and cryptocurrency world, as well as offering private banking services to high net worth individuals who are trading or investing in crypto assets."
        },
        flex: {
            left: "Crypto-savvy companies, trustees and private investors can invest in both conventional and crypto assets, while at the same time allowing them to enjoy all of the benefits of day-to-day account and professional payment transaction management, as well as a securities custody account for trading in shares, investment funds, bonds and precious metals.",
            right: "Based on our team’s many years of experience in this area, we fully understand the underlying technology as well as the various business models – from blockchain start-ups to established crypto exchanges and crypto brokers."
        },
        services_list_block: {
            title: "Our services in Regulated Digital Assets Banking:",
            left_list_block: {
                line1: {
                    title: "Multi-Currency Bank Accounts (MCA)",
                    text: "As a fully regulated bank, the security of your assets is our core business. We are just as prudent with your crypto assets as we are with conventional assets. We offer free conversions between selected USD stablecoins and fiat USD, allowing you to operate them interchangeably in your account. We also support Bitcoin as a currency within the MCA. Benefit from professional management of your payment transactions by an experienced back-office team."
                },
                line2: {
                    title: "OTC Crypto trading",
                    text: "Trade leading cryptocurrencies with us on a spot basis. You can call our trading desk for quotes any time and settle the transactions via your MCA."
                }
            },
            right_list_block: {
                line1: {
                    title: "Escrow account",
                    text: "We support third party OTC fiat-crypto transactions by providing trusted intermediary services in a secure, regulated offshore environment. Both parties must onboard and open MCAs with our Bank, at which point an escrow agreement can be set up for a major OTC transaction. Fiat funds will be deposited in an MCA allowing them to be released to the counterparty in real time as soon as the crypto transaction is confirmed on the blockchain. Contact us to discuss escrow fees."
                },
                line2: {
                    title: "Business account for Digital Assets companies",
                    text: "Lombard loans and mortgages secured by digital assets, securities and cash balances"
                }
            }
        },
        gradient_block: {
            open_text1: "All clients will be allocated a private banker so they know immediately who to contact whenever any banking services are needed. Our private bankers speak most global languages.",
            open_text2: "You can initiate the account opening process online to see our services for yourself, or find out more about our Blockchain Banking offer by booking an online appointment with our International Digital Assets Banking team today!",
            btn_title: "Open Account"
        }
    },
    ru: {
        hero: {
            title_1: "Банковские услуги",
            title_2: "для цифровых активов",
            description:
                "Цифровые активы являются частью нашей ДНК, так же как и личные контакты с нашими клиентами. Мы являемся ведущим банком, который объединяет мир криптовалют и надежно регулируемую офшорную банковскую среду.",
        },
        coins_block: {
            description:
                "Мы предоставляем комплексные банковские услуги как для устоявшихся, так и для стартапов из мира блокчейна и криптовалют, а также предлагаем частные банковские услуги для состоятельных клиентов, которые торгуют или инвестируют в криптоактивы.",
        },
        flex: {
            left:
                "Компании, разбирающиеся в криптовалютах, доверительные управляющие и частные инвесторы могут инвестировать как в традиционные, так и в криптоактивы, одновременно получая все преимущества управления текущими счетами и профессиональными платежными транзакциями, а также счета хранения ценных бумаг для торговли акциями, инвестиционными фондами, облигациями и драгоценными металлами.",
            right:
                "Основываясь на многолетнем опыте нашей команды в этой области, мы полностью понимаем базовые технологии, а также различные бизнес-модели – от стартапов в области блокчейна до устоявшихся криптобирж и криптоброкеров.",
        },
        services_list_block: {
            title: "Наши услуги в области регулируемого банковского обслуживания цифровых активов:",
            left_list_block: {
                line1: {
                    title: "Мультивалютные банковские счета (MCA)",
                    text:
                        "Как полностью регулируемый банк, безопасность ваших активов является нашим основным бизнесом. Мы так же осторожны с вашими криптоактивами, как и с традиционными активами. Мы предлагаем бесплатные конверсии между выбранными стейблкоинами USD и фиатными USD, позволяя вам использовать их взаимозаменяемо на вашем счете. Мы также поддерживаем биткойн как валюту в MCA. Воспользуйтесь профессиональным управлением вашими платежными транзакциями опытной командой бэк-офиса.",
                },
                line2: {
                    title: "OTC-криптоторговля",
                    text:
                        "Торгуйте ведущими криптовалютами с нами на спотовой основе. Вы можете в любое время позвонить на нашу торговую площадку для получения котировок и осуществлять сделки через ваш MCA.",
                }
            },
            right_list_block: {
                line1: {
                    title: "Эскроу-счет",
                    text:
                        "Мы поддерживаем сделки OTC с фиатными и криптовалютами, предоставляя надежные посреднические услуги в безопасной, регулируемой офшорной среде. Обе стороны должны пройти регистрацию и открыть MCA в нашем банке, после чего можно будет заключить эскроу-соглашение для крупной OTC-сделки. Фиатные средства будут внесены на MCA, что позволит их освободить контрагенту в реальном времени, как только криптосделка будет подтверждена в блокчейне. Свяжитесь с нами, чтобы обсудить комиссии за эскроу."
                },
                line2: {
                    title: "Бизнес-счет для компаний цифровых активов",
                    text: "Ломбардные кредиты и ипотеки, обеспеченные цифровыми активами, ценными бумагами и денежными остатками."
                }
            }
        },
        gradient_block: {
            open_text1:
                "Каждому клиенту будет назначен личный банкир, чтобы он сразу знал, к кому обратиться, когда понадобятся банковские услуги. Наши частные банкиры говорят на большинстве мировых языков.",
            open_text2:
                "Вы можете начать процесс открытия счета онлайн, чтобы ознакомиться с нашими услугами, или узнать больше о нашем предложении по блокчейн-банкингу, записавшись на онлайн-встречу с нашей командой международного банковского обслуживания цифровых активов уже сегодня!",
            btn_title: "Открыть счет"
        }
    },
    fas: {
        hero: {
            title_1: "بانکداری دارایی های",
            title_2: "دیجیتال",
            description: "داراییهای دیجیتال، درست مانند ارتباط شخصی با مشتریانمان، بخشی از DNA ما هستند. ما بانک پیشرو در ترکیب دنیای ارزهای دیجیتال و محیط بانکداری برونمرزیِ امن و تحت نظارت هستیم."
        },
        coins_block: {
            description: "ما خدمات بانکی جامع برای شرکتهای تأسیسشده و استارتاپها در دنیای بلاکچین و ارزهای دیجیتال ارائه میدهیم. علاوه بر این، خدمات بانکداری خصوصی به افراد با دارایی بالا که در حال معامله یا سرمایهگذاری در داراییهای دیجیتال هستند، ارائه میکنیم."
        },
        flex: {
            left: "شرکتها، امانتداران و سرمایهگذاران خصوصی آگاه به ارز دیجیتال میتوانند هم در داراییهای سنتی و هم در داراییهای دیجیتال سرمایهگذاری کنند. در عین حال، این امکان را دارند که از مزایای مدیریت حسابهای روزانه و تراکنشهای پرداخت حرفهای بهرهبرداری کنند و همچنین از حسابهای امانی برای معامله در سهام، صندوقهای سرمایهگذاری، اوراق قرضه و فلزات گرانبها استفاده کنند.",
            right: "با توجه به تجربه چندین ساله تیم ما در این حوزه، ما بهطور کامل فناوریهای زیرساختی و مدلهای تجاری مختلف را درک میکنیم، از استارتاپهای بلاکچینی تا صرافیها و کارگزاران معتبر ارز دیجیتال."
        },
        services_list_block: {
            title: "خدمات ما در زمینه بانکداری داراییهای دیجیتال تحت نظارت:",
            left_list_block: {
                line1: {
                    title: "حسابهای بانکی چند ارزی (MCA)",
                    text: 
                        "به عنوان یک بانک کاملاً تحت نظارت، امنیت داراییهای شما جزء اصلی کسبوکار ماست. ما با داراییهای دیجیتال شما همانطور که با داراییهای معمولی رفتار میکنیم، با احتیاط برخورد میکنیم. ما تبدیلهای رایگان بین برخی از استیبل کوینهای  USD و دلار آمریکا ارائه میدهیم، به طوری که میتوانید آنها را بهطور متقابل در حساب خود استفاده کنید. همچنین بیتکوین را به عنوان یک ارز در حساب چند ارزی (MCA) پشتیبانی میکنیم. از مدیریت حرفهای تراکنشهای پرداختی خود توسط تیم پشتیبانی با تجربه بهرهمند شوید ."
                },
                line2: {
                    title: "معاملات کریپتو خارج از بورس (OTC)",
                    text: "با ما، ارزهای دیجیتال پیشرو را به صورت لحظهای (spot) معامله کنید. شما میتوانید هر زمان که نیاز داشتید برای دریافت قیمتها با میز معامله ما تماس بگیرید و تراکنشها را از طریق حساب چند ارزی (MCA) خود تسویه کنید"
                }
            },
            right_list_block: {
                line1: {
                    title: "حساب امانی",
                    text: 
                        "ما از تراکنشهای OTC فیات-کریپتو با حمایت از خدمات میانجیگری معتبر در یک محیط امن و تحت نظارت حمایت میکنیم. هر دو طرف باید با بانک ما حسابهای MCA باز کنند تا قرارداد امانی برای یک تراکنش بزرگ OTC تنظیم شود. وجوه فیات در حساب MCA سپردهگذاری شده و به محض تأیید تراکنش کریپتو در بلاکچین، به طرف مقابل منتقل میشود. برای مشاوره در مورد هزینههای امانی با ما تماس بگیرید ."
                },
                line2: {
                    title: "حساب تجاری برای شرکتهای داراییهای دیجیتال",
                    text: "وامهای لومبارد و وامهای مسکن که با داراییهای دیجیتال، اوراق بهادار و موجودیهای نقدی تأمین میشوند"
                }
            }
        },
        gradient_block: {
            open_text1: "تمامی مشتریان یک بانکدار خصوصی اختصاصی خواهند داشت تا به راحتی بدانند در صورت نیاز به خدمات بانکی، با چه کسی تماس بگیرند.",
            open_text2: "بانکداران خصوصی ما به بیشتر زبانهای جهانی مسلط هستند . شما میتوانید فرآیند افتتاح حساب را به صورت آنلاین آغاز کنید تا خدمات ما را خودتان بررسی کنید، یا با رزرو یک وقت آنلاین از تیم بانکداری داراییهای دیجیتال بینالمللی ما، اطلاعات بیشتری درباره پیشنهادات بانکداری بلاکچین ما دریافت کنید",
            btn_title: "یک حساب کاربری باز کنید"
        }
    },
};

const tradeFinanceTranslations = {
    en: {
        hero: {
            title_1: "Trade",
            title_2: "Finance",
            description: "In foreign trade you are constantly confronted with challenges. Contractual and punctual delivery, payment security, and counterparty credit risk on top of political and economic uncertainty. With Wall Street IBU’s products and services, we help you to hedge the risks associated with your global payments exposure."
        },
        trade_desc: {
            paragraph1: "All the while, you will benefit from our private banking touch. As a niche player, we are able to advise instruments directly or through corresponding banks worldwide so that documents are endorsed by prime money center banks.",
            paragraph2: "As a Wall Street IBU corporate account holder, you are guaranteed direct contact with a Trade Finance and Documentary Credit expert. This way our clients have their instruments endorsed by prime banks without the undoubted inconvenience of having to deal with the large institutions.",
            imageAlt1: "Trade Description",
            imageAlt2: "Trade Description 2",
            imageAlt3: "Trade Description 3"
        },
        instrument_header: "Trade finance clients come from various backgrounds with different needs.",
        instrument_subheader: "The instruments that clients require can be differentiated in:",
        instrument: {
            bullet1: "Their instrument size",
            bullet2: "Instrument duration",
            bullet3: "Payment structure",
            bullet4: "Rating of issuing bank",
            bullet5: "The relationship the client maintains with their banks",
            bullet6: "Rating of advising bank"
        },
        secondBlock: {
            paragraph1: "We are also aware that the arena of Trade Finance can be complicated to understand for clients who are more focused in their manufacturing/commodities business. Wall Street Ibu works smoothly with brokers and representatives of those clients to best arrive at a dynamic solution.",
            paragraph2: "Ultimately, we always maintain a client-focused vision to arrive and provide the best solution for the client and find a regulation-compliant solution."
        },
        cards_header: "Our Trade Finance division focuses on providing clients with the best solution to their unique needs. This involves providing issuance, collection and endorsement of, but not limited to, the following:",
        card1: {
            title: "Bank Guarantee (BG)",
            text: "A Bank Guarantee proves to your international trading partners that you are dependable. Our offer includes direct or indirect guarantees, payment guarantees, bank guarantees and delivery and performance guarantees, depending on what you want to secure. Providing your customers and contractors with security gives you a competitive advantage. For each transaction we will tailor-make a guarantee with you. Alternatively, we will make use of the standardized formulations of the ICC."
        },
        card2: {
            title: "Letter of Credit (LC)",
            text: "As a bank we are a specialist in niche and emerging markets. We provide customized solutions to multi-jurisdictional entities, individuals, and families to protect and enhance wealth. We enable them to execute business transactions across the globe in a secure, efficient and transparent manner. As a trusted partner for modern offshore banking, our solutions are based on the latest and secure technological platforms. We support your global success and ensure your international transactions reach their destination at all times."
        },
        card3: {
            title: "Standby Letter of Credit (SBLC)",
            text:
                "A Standby Letter of credit is a special type of LC that works as a standby guarantee to the seller. If the buyer fails to meet his obligation, the bank will cover the payment; that’s why It’s called “standby”. If the seller requires payment advance of the goods or services, the standby letter of credit can act as a payment guarantee. The advance payment standby letter of credit protects against one party’s failure to pay the other party’s advance payment.It is not drawn down unless some unwanted incident like a buyer’s default or bankruptcy."
        },
        thirdBlock: {
            paragraph1: "Wall Street IBU is proud to offer its trade finance correspondent network and relationship to its clients. We are able to advise instruments directly or through prime corresponding banks worldwide.",
            paragraph2: "With a flexible team, our Trade Finance Desk creates innovative trade finance solutions for complex needs. Our flexibility and specialist team lets us offer very competitive rates as compared to the market."
        },
        factor: {
            header: "Trade finance clients come from various backgrounds with different needs.",
            subheader: "The instruments that clients require can be differentiated in:",
            bullet1: "The format in which the instrument must be communicated (SWIFT message type, KTT Telex or paper based)",
            bullet2: "If the instrument needs to be advised or confirmed from one of our partner institutions or a Prime Money Center Bank",
            bullet3: "Size of the Instrument (value and currency)",
            bullet4: "Verbiage of Instrument",
            bullet5: "Duration for which the Instrument must be open"
        },
        whoWe: {
            boldText: "At Wall Street Ibu",
            paragraph1: "we require that fees for the instruments are paid before we issue the instrument. However, in order to provide protection to clients we always offer a free draft of the LC/BG to the client before requiring any fees.",
            paragraph2: "This way the client may present the draft to the other party’s bank before we go ahead with official bank-to-bank communication. This also ensures that the instrument is suitable for the exact requirements of our clients.",
            paragraph3: "Once fees are received the instrument (LC/BG) is issued within 48 hours. Certain factors such as time zones come into play when determining exact turn around time."
        },
        gradient: {
            title: "Issue of Trade Finance Instruments is subject to various internationally agreed rules, including:",
            left: {
                line1: "The rules of documentary credits",
                line2: "Publication 600 of the International Chamber of Commerce",
                line3: "The Uniform Collection Rules (UCR)"
            },
            right: {
                line1: "Publication 552 of the International Chamber of Commerce",
                line2: "The International Standby Practices ISP 98 rules"
            },
            footer: {
                bold: "Important Note:",
                text: " Currently, due to unprecedented high demand, our Trade Finance Desk is only accepting new trade finance business from our Commercial Account Holders who have first completed onboarding due diligence with a Multi-Currency Account (MCA) with a minimum funded cash balance of ",
                highlight: "50,000 USD/EUR/GBP",
                rest: ". We unfortunately cannot provide nor discuss our Trade Finance Services with persons who are not existing clients of our bank adhering to the minimum stated."
            }
        }
    },
    ru: {
        hero: {
            title_1: "Торговое",
            title_2: "финансирование",
            description:
                "В международной торговле вы постоянно сталкиваетесь с вызовами. Договорная и своевременная доставка, безопасность платежей и кредитный риск контрагента на фоне политической и экономической неопределенности. С продуктами и услугами Wall Street IBU мы помогаем вам хеджировать риски, связанные с вашими глобальными платежами.",
        },
        trade_desc: {
            paragraph1:
                "При этом вы будете пользоваться нашим индивидуальным банковским подходом. Как нишевый игрок, мы можем консультировать по инструментам напрямую или через корреспондентские банки по всему миру, чтобы документы были подтверждены первоклассными банками.",
            paragraph2:
                "Как держатель корпоративного счета Wall Street IBU, вы гарантированно получите прямой контакт с экспертом по торговому финансированию и документарным кредитам. Таким образом, наши клиенты получают подтверждение своих инструментов от первоклассных банков без неудобств, связанных с работой с крупными учреждениями.",
            imageAlt1: "Описание торгового блока",
            imageAlt2: "Описание торгового блока 2",
            imageAlt3: "Описание торгового блока 3"
        },
        instrument_header: "Клиенты по торговому финансированию приходят из различных сфер с разными потребностями.",
        instrument_subheader: " Инструменты, которые требуются клиентам, можно классифицировать по:",
        instrument: {
            bullet1: "Размеру инструмента",
            bullet2: "Сроку действия инструмента",
            bullet3: "Структуре платежа",
            bullet4: "Рейтингу эмитента банка",
            bullet5: "Отношениям, которые клиент поддерживает со своими банками",
            bullet6: "Рейтингу консультирующего банка"
        },
        secondBlock: {
            paragraph1:
                "Мы также осознаем, что сфера торгового финансирования может быть сложной для понимания клиентами, которые больше сосредоточены на своем производстве/товарах. Wall Street IBU работает в тесном сотрудничестве с брокерами и представителями этих клиентов, чтобы найти динамичное решение.",
            paragraph2:
                "В конечном итоге мы всегда сохраняем ориентированный на клиента подход, чтобы найти и предоставить лучшее решение для клиента и найти соответствующее",
        },
        cards_header:
            "Наше подразделение торгового финансирования сосредоточено на предоставлении клиентам наилучших решений для их уникальных потребностей. Это включает в себя выпуск, сбор и подтверждение, но не ограничивается следующими:",
        card1: {
            title: "Банковская гарантия (BG)",
            text:
                "Банковская гарантия подтверждает вашим международным торговым партнерам, что вы надежны. Наше предложение включает прямые или косвенные гарантии, гарантии платежа, банковские гарантии, а также гарантии поставки и исполнения, в зависимости от того, что вы хотите обеспечить. Обеспечение ваших клиентов и подрядчиков гарантией дает вам конкурентное преимущество. Для каждой сделки мы индивидуально разработаем гарантию вместе с вами. В качестве альтернативы мы воспользуемся стандартизированными формулировками ICC."
        },
        card2: {
            title: "Аккредитив (LC)",
            text:
                "Аккредитив — это проверенный инструмент для обеспечения платежей через национальные границы. В соответствии с инструкциями клиента банк обязан произвести платеж, если представлены соответствующие документы. Хеджирование через аккредитив предоставляет торговцам высокую степень уверенности в том, что они получат причитающиеся суммы. Банк покупателя гарантирует, что сумма счета будет оплачена, если условия, согласованные в аккредитиве, выполнены. Стандартизированные условия обеспечивают безопасность в процессе расчетов."
        },
        card3: {
            title: "Резервный аккредитив (SBLC)",
            text:
                'Резервный аккредитив — это особый вид аккредитива, который работает как резервная гарантия для продавца. Если покупатель не выполняет свои обязательства, банк покроет платеж; поэтому он называется "резервным". Если продавец требует предоплату за товары или услуги, резервный аккредитив может выступать в качестве гарантии платежа. Резервный аккредитив на предоплату защищает от неисполнения одной стороной обязательств по предоплате другой стороны. Он не используется, если не произойдет нежелательное событие, такое как дефолт покупателя или банкротство.',
        },
        thirdBlock: {
            paragraph1:
                "Wall Street IBU гордится тем, что предлагает своим клиентам сеть корреспондентского торгового финансирования и отношения. Мы можем консультировать по инструментам напрямую или через первоклассные корреспондентские банки по всему миру.",
            paragraph2:
                "С гибкой командой наш отдел торгового финансирования создает инновационные решения для сложных потребностей. Наша гибкость и специализированная команда позволяют нам предлагать очень конкурентные ставки по сравнению с рынком."
        },
        factor: {
            header: "Стоимость аккредитива/банковской гарантии зависит от различных факторов:",
            subheader: "",
            bullet1: "Формат, в котором инструмент должен быть передан (тип сообщения SWIFT, KTT Telex или на бумаге)",
            bullet2: "Если инструмент необходимо уведомить или подтвердить одним из наших партнерских учреждений или банка первичного денежного центра",
            bullet3: "Размер инструмента (стоимость и валюта)",
            bullet4: "Формулировка инструмента",
            bullet5: "Срок, на который инструмент должен быть открыт"
        },
        whoWe: {
            boldText: "В Wall Street IBU",
            paragraph1: "мы требуем, чтобы сборы за инструменты были оплачены до их выпуска. Однако, чтобы обеспечить защиту клиентам, мы всегда предлагаем бесплатный проект LC/BG клиенту перед тем, как потребовать какие-либо сборы.",
            paragraph2: "Таким образом, клиент может представить проект в банк другой стороны, прежде чем мы продолжим официальное банковское взаимодействие. Это также гарантирует, что инструмент соответствует точным требованиям наших клиентов.",
            paragraph3: "После получения сборов инструмент (LC/BG) выдается в течение 48 часов. Определенные факторы, такие как часовые пояса, влияют на определение точного времени выполнения."
        },
        gradient: {
            title: "Выпуск торговых финансовых инструментов подлежит различным международно согласованным правилам, включая:",
            left: {
                line1: "Правила документарных аккредитивов",
                line2: "Публикация 600 Международной торговой палаты",
                line3: "Унифицированные правила инкассо (UCR)"
            },
            right: {
                line1: "Публикация 552 Международной торговой палаты",
                line2: "Правила Международной практики резервного аккредитива ISP 98"
            },
            footer: {
                bold: "Важное замечание:",
                text:
                    "Важное примечание: В настоящее время, из-за беспрецедентного высокого спроса, наш отдел торгового финансирования принимает новые заявки на торговое финансирование только от наших коммерческих клиентов, которые сначала прошли процедуру проверки при onboarding с мультивалютным счетом (MCA) с минимальным остатком на счете",
                highlight: "50,000 USD/EUR/GBP. ",
                rest:
                    "К сожалению, мы не можем предоставить или обсудить наши услуги торгового финансирования с лицами, которые не являются существующими клиентами нашего банка и не соответствуют указанным минимальным требованиям."
            }
        }
    },
    fas: {
        hero: {
            title_1: "امور مالی ",
            title_2: "تجاری",
            description: "در تجارت خارجی، شما همواره با چالشهایی مواجه هستید، از جمله تحویل به موقع، امنیت پرداخت، ریسک اعتباری طرف مقابل و عدم اطمینان سیاسی و اقتصادی. با محصولات و خدمات Wall Street IBU ، ما به شما کمک میکنیم تا ریسکهای مربوط به پرداختهای جهانی خود را پوشش دهید و از امنیت و کارآیی در معاملات بینالمللی اطمینان حاصل کنید ."
        },
        trade_desc: {
            paragraph1: "در طول این فرآیند، شما از خدمات بانکداری خصوصی ما بهرهمند خواهید شد. به عنوان یک بازیگر تخصصی، ما قادر به مشاوره درباره ابزارهای مالی بهطور مستقیم یا از طریق بانکهای همکار در سراسر جهان هستیم تا مدارک توسط بانکهای معتبر جهانی تایید شوند.",
            paragraph2: " به عنوان دارنده حساب شرکتی در وال استریت آیبییو، شما از تماس مستقیم با کارشناسان تأمین مالی تجارت و اعتبار اسنادی بهرهمند خواهید شد. به این ترتیب، مشتریان ما میتوانند ابزارهای مالی خود را از طریق بانکهای معتبر جهانی تأیید کنند، بدون آنکه با مشکلات احتمالی ناشی از تعامل با نهادهای بزرگ مواجه شوند.",
            imageAlt1: "Trade Description",
            imageAlt2: "Trade Description 2",
            imageAlt3: "Trade Description 3"
        },
        instrument_header: "مشتریان تأمین مالی تجارت از زمینههای مختلف با نیازهای متفاوت به خدمات ما مراجعه میکنند.",
        instrument_subheader: "ابزارهایی که مشتریان به آنها نیاز دارند میتوانند از جنبههای مختلفی تمایز داشته باشند، از جمله :",
        instrument: {
            bullet1: "اندازه ابزار",
            bullet2: "مدتزمان ابزار",
            bullet3: "ساختار پرداخت",
            bullet4: "رتبهبندی بانک صادرکننده",
            bullet5: "رابطه مشتری با بانکها",
            bullet6: "رتبهبندی بانک مشاور"
        },
        secondBlock: {
            paragraph1: "آگاه هستیم که عرصه تأمین مالی تجاری میتواند برای مشتریانی که بیشتر بر کسبوکارهای تولیدی یا کالاهای خود تمرکز دارند پیچیده باشد. وال استریت IBU بهطور مؤثر با کارگزاران و نمایندگان این مشتریان همکاری میکند تا بهترین راهحلهای پویا را بهدست آورد.",
            paragraph2: "در نهایت، ما همیشه رویکردی مشتریمحور داریم تا بهترین راهحلها را ارائه دهیم و اطمینان حاصل کنیم که راهحلها با مقررات تطابق دارند ."
        },
        cards_header: "واحده امور تأمین مالی تجاری ما بر روی ارائه بهترین راهحلها برای نیازهای منحصر به فرد مشتریان تمرکز دارد. این شامل ارائه صدور، جمعآوری و تایید موارد زیر است، اما محدود به آنها نیست",
        card1: {
            title: "ضمانتنامه بانکی (BG)",
            text: "ضمانتنامه بانکی به شریکان تجاری بینالمللی شما ثابت میکند که شما قابل اعتماد هستید. این خدمات شامل ضمانتهای مستقیم و غیرمستقیم، ضمانت پرداخت، ضمانت بانکی و ضمانتهای تحویل و عملکرد میشود، که بسته به نیاز شما قابل تنظیم است. ارائه امنیت به مشتریان و پیمانکاران شما، مزیت رقابتی ایجاد میکند. برای هر تراکنش، ما یک ضمانت ویژه طراحی خواهیم کرد یا از فرمولههای استاندارد ICC استفاده میکنیم ."
        },
        card2: {
            title: "نامه اعتبار (LC)",
            text: "به عنوان یک بانک، ما متخصص در بازارهای خاص و نوظهور هستیم. ما راهحلهای سفارشی برای نهادها، افراد و خانوادههای چند حوزه قضایی ارائه میدهیم تا ثروت خود را حفظ و افزایش دهند. ما به آنها این امکان را میدهیم که معاملات تجاری را در سراسر جهان به شیوهای امن، کارآمد و شفاف انجام دهند. به عنوان یک شریک قابل اعتماد برای بانکداری مدرن فراساحلی، راهحلهای ما بر اساس جدیدترین و امنترین پلتفرمهای فناوری است. ما از موفقیت جهانی شما حمایت کرده و اطمینان حاصل میکنیم که معاملات بینالمللی شما به مقصد خود میرسند"
        },
        card3: {
            title: "اعتبار اسنادی آماده به کار (SBLC)",
            text:
                "یک اعتبارنامه پشتیبان نوع خاصی از اعتبارنامه است که به عنوان ضمانت پشتیبان برای فروشنده عمل میکند. اگر خریدار نتواند تعهدات خود را انجام دهد، بانک پرداخت را پوشش میدهد. این اعتبارنامه برای تضمین پیشپرداخت کالا یا خدمات نیز استفاده میشود و فقط در صورت وقوع حادثهای مانند ورشکستگی یا عدم پرداخت خریدار فعال میشود."
        },
        thirdBlock: {
            paragraph1: "مفتخر است که شبکه و روابط مالی تجاری خود را به مشتریانش ارائه میدهد. ما قادر به مشاوره در مورد ابزارهای مالی بهطور مستقیم یا از طریق بانکهای همکار معتبر در سراسر جهان هستیم .",
            paragraph2: "با تیمی انعطافپذیر، میز تجارت فاینانس ما راهحلهای نوآورانهای برای نیازهای پیچیده ارائه میدهد. انعطافپذیری و تخصص تیم ما این امکان را فراهم میآورد که نرخهای بسیار رقابتیتری نسبت به بازار ارائه دهیم."
        },
        factor: {
            header: "مشتریان تجارت فاینانس از زمینههای مختلف با نیازهای متفاوت میآیند. ",
            subheader: "ابزارهایی که مشتریان نیاز دارند میتوانند بر اساس موارد زیر تفکیک شوند:",
            bullet1: "فرمت ارتباط ابزار ( نوع پیام SWIFT ، KTT Telex یا مبتنی بر کاغذ",
            bullet2: "اگر ابزار باید توسط یکی از موسسات شریک یا یک بانک اصلی تأسیسکننده تأیید یا مشاوره شود",
            bullet3: "اندازه ابزار (ارزش و ارز)",
            bullet4: "عبارت ابزار",
            bullet5: "مدت زمانی که ابزار باید باز باشد"
        },
        whoWe: {
            boldText: "در وال استریت IBU ",
            paragraph1: "، ما درخواست میکنیم که هزینههای مربوط به ابزارها قبل از صدور آنها پرداخت شود. با این حال، برای محافظت از مشتریان، ما همیشه پیشنویس رایگان LC/BG را قبل از دریافت هرگونه هزینه به مشتری ارائه میدهیم.",
            paragraph2: "به این ترتیب، مشتری میتواند پیشنویس را به بانک طرف مقابل ارائه دهد قبل از اینکه ما ارتباط رسمی بین بانکها را آغاز کنیم.",
            paragraph3: "این همچنین تضمین میکند که ابزار به نیازهای دقیق مشتریان ما تطابق دارد. پس از دریافت هزینهها، ابزار (LC/BG) ظرف 48 ساعت صادر میشود. عواملی مانند مناطق زمانی در تعیین زمان دقیق تحویل مؤثر هستند."
        },
        gradient: {
            title: "صدور ابزارهای تأمین مالی تجارت مشمول قوانین مختلف بینالمللی است که شامل موارد زیر میباشد:",
            left: {
                line1: "قوانین اعتبار مستند",
                line2: "نشریه 600 اتاق بازرگانی بینالمللی",
                line3: "قوانین جمعآوری یکسان (UCR)"
            },
            right: {
                line1: "نشریه 552 اتاق بازرگانی بینالمللی",
                line2: "قوانین ISP 98 برای ضمانتنامههای پشتیبان بینالمللی"
            },
            footer: {
                bold: "نکته مهم: ",
                text: "در حال حاضر، به دلیل تقاضای بیسابقه، میز تجاری ما فقط از مشتریان حسابهای تجاری که فرآیند تأسیس حساب  (MCA)با حداقل موجود ",
                highlight: "50,000  دلار/یورو/پوند",
                rest: "را تکمیل کردهاند، پذیرش جدید میکند. متأسفانه نمیتوانیم(MCA)خدمات تأمین مالی تجارت را به افرادی که مشتریان فعلی بانک ما نیستند ارائه دهیم ."
            }
        }
    },
};

const faqTranslations = {
    en: {
        hero: {
            title: "FAQ",
            description: "Here, we have compiled answers to the most common inquiries to help you navigate our services and find the information you need quickly and efficiently. Whether you're looking for detailed explanations about our offerings, troubleshooting guidance, or insights into our policies, this section is designed to address your concerns. If you don't find the answer you're looking for, please don't hesitate to contact us directly—our team is always ready to assist."
        },
        faq1: {
            title: "Can I apply for a Bank account online or do I have to visit your offices?",
            text:
                "Yes you can apply and be approved online. Wall Street Ibu is a digital bank. All bank account applications are handled online. Personal visits to the Bank’s headquarters or any of the Bank’s branches located around the world are welcome, but not required. After applying for your account online, you will be contacted by the Bank’s International Private Banking or International Commercial banking officers to complete an interview online before the process is finalized and account number is allocated. At Wall Street Ibu we pride ourselves on flexibility and bespoke solutions. Our service is aimed at wealthy, international individuals who are likely to deposit $1 million upwards. For us the most important thing is that our business relationship should be mutually beneficial. This is only fair and applies both ways. Due to the high level of personal service we provide, and due to the fees we charge for our services, it is not worth our while to service very small accounts. Smaller clients will probably find our fees disproportionate and would perhaps be better served by a domestic bank in their home countries or a fintech/EMI/PSP type institution rather than a fully regulated bank. However, each case is different and we are cognizant that a small account may bring substantial business in the future as clients may be expecting a liquidity event or may be in a position to refer in other larger clients. Therefore we do not have any fixed minimum deposit and we are happy to open accounts with zero balance provided onboarding fees are paid according to our standard tariff."
        },
        faq2: {
            title: "How long does it take to open an account?",
            text: "We can typically open International Private Banking (personal) Multi-Currency Accounts within 24-48 hours and International Commercial Accounts within 1-2 weeks. In some cases it may be possible to open accounts faster in case of urgent need. On the other hand, in some cases account opening may take longer if extended due diligence procedures are required. Please discuss your individual circumstances with our International Private Bankers."
        },
        faq3: {
            title: "Can I transfer my existing investment portfolio to the Bank?",
            text: "Yes, you can. Bank customers can transfer their existing investment portfolio such as stocks, bonds, mutual funds, precious metals, digital assets, private equity, and other products to the Bank through our collaboration with various global asset custodian banks. Your International Private Banker will be able to make arrangements and inform you of the exact procedures to follow depending on the asset classes involved."
        },
        faq4: {
            title: "Can the Bank help me to register a new company or trust?",
            text: "The Bank itself does not handle incorporations directly but we work very closely with incorporation agents in the various jurisdictions where we work. This allows us to share due diligence (you only need to provide one set of documents) and have the bank account ready on the same day the incorporation certificate is issued. In many cases it is beneficial for a client to open a corporate rather than a personal account. Please discuss your individual requirements with your Wall Street Ibu International Private Banker."
        },
        faq5: {
            title: "What are your wire instructions for inbound SWIFT transfers?",
            text:
                "All Wall Street Ibu accounts are Multi-Currency Accounts and can handle various currencies for inbound and outbound transfers. Unfortunately the international banking system is not as advanced as we are. If you send payments without intermediary bank information there is a high chance they will be lost, delayed, involuntarily converted to another currency and/or have large fees deducted by intermediary banks over which we have no control. These intermediary banks are chosen by the bank that is sending the funds, not by Wall Street Ibu. In order to receive funds in your account. we therefore need to provide you with different transaction instructions depending on factors such as the currency, source, and type of your payment. Your Wall Street Ibu International Private Banker will send you instructions for US dollar and Euro deposits as soon as your account is opened. If you require wire instructions for another currency you simply need to ask.",
        },
        faq6: {
            title: "Do you support the SWIFT GPI system?",
            text:
                "Yes, we do. You should ask sending banks to use this system if possible. SWIFT gpi is a new generation SWIFT payment system that is only supported by a limited number of banks at the moment If you or your counterparties send funds to us using SWIFT gpi, you will receive a UETR code (Unique End-to-End Transaction Reference) for your transfer which you can use to check the progress of the transfer in real time and see the fees charged by the various agent banks in a more transparent manner. As soon as you are aware that a SWIFT gpi payment has been sent, you just need to send a copy to your International Private Banker. Our Operations Department can then typically see the payment on the system immediately. At the moment we unfortunately do not have this facility for outgoing payments due to the multiple rails we use. We are seeking to implement it in the near future."
        },
        faq7: {
            title: "Do you provide direct IBAN numbers?",
            text:
                "Yes, we do. IBAN stands for International Bank Account Number and is a standardized system for account numbers that is used mainly in Europe and the Middle East. It is not used in other major markets like North America or Asia. Currently our jurisdiction is not part of the IBAN system, but we have arranged with our correspondents in Europe to offer virtual IBAN accounts in European currencies such as EUR, GBP, CHF. The advantage of this is that your wire instructions are simpler and clearer, reducing the potential for error.A virtual IBAN account means that you will appear to have an account in a European financial institution in your name, and our bank’s name will not appear in the coordinates. This is also known as a “Payable Through” account. However, as soon as funds hit the virtual account they will be immediately credited to your Wall Street Ibu Multi-Currency Account. Virtual IBANs are a convenience service for our Private Banking Clients. Our correspondents may restrict their use for residents or citizens of certain countries. If this applies to you, you can still receive SWIFT transfers through the conventional method, using our SWIFT code WSBOKMK1 or via other payment methods."
        },
        faq8: {
            title: "Do you accept check or cash deposits?",
            text:
                "As a digital bank, we do not accept check or cash deposits. Paper checks are no longer in common use for international payments. If you need to deposit funds by cash or check to your Wall Street Ibu account, we do have solutions in certain countries via third party partners such as bureaux de change or cambio offices. Please inquire about availability of these services with your International Private Banker."
        }
    },
    ru: {
        hero: {
            title: "Часто задаваемые вопросы",
            description:
                "Здесь мы собрали ответы на самые распространенные вопросы, чтобы помочь вам ориентироваться в наших услугах и быстро и эффективно находить нужную информацию. Если вы ищете подробные объяснения о наших предложениях, руководство по устранению неполадок или информацию о наших политиках, этот раздел предназначен для решения ваших вопросов. Если вы не нашли ответ на свой вопрос, пожалуйста, не стесняйтесь обращаться к нам напрямую — наша команда всегда готова помочь."
        },
        faq1: {
            title:
                "Могу ли я подать заявку на открытие банковского счета онлайн или мне нужно посетить ваши офисы?",
            text: "Да, вы можете подать заявку и получить одобрение онлайн. Wall Street Ibu — цифровой банк. Все заявки на открытие счета обрабатываются онлайн. Личные визиты в главный офис банка или в любое из отделений по всему миру приветствуются, но не обязательны.\nПосле подачи заявки онлайн с вами свяжутся специалисты Международного частного или коммерческого банкинга для прохождения онлайн-интервью, после чего процесс будет завершен и вам будет присвоен номер счета.\nВ Wall Street Ibu мы гордимся гибкостью и индивидуальным подходом. Наши услуги предназначены для состоятельных международных клиентов, которые, как правило, вносят от 1 миллиона долларов и выше. Для нас самое важное — взаимовыгодное сотрудничество. Из-за высокого уровня персонального обслуживания и наших комиссий работа с маленькими счетами для нас невыгодна. Более мелкие клиенты могут найти наши сборы непропорциональными и, возможно, лучше обслуживаться местным банком или финтех/EMI/PSP учреждением, а не полностью регулируемым банком. Однако каждый случай индивидуален, и мы понимаем, что небольшой счет может в будущем принести значительный бизнес, если клиент ожидает ликвидного события или может порекомендовать более крупных клиентов."
        },
        faq2: {
            title: "Сколько времени занимает открытие счета?",
            text: "Обычно мы открываем Международные частные банковские (персональные) мультивалютные счета в течение 24-48 часов, а Международные коммерческие счета — в течение 1-2 недель. В некоторых случаях процесс может пройти быстрее при срочной необходимости. В отдельных случаях процесс может затянуться, если требуется дополнительная проверка. Пожалуйста, обсудите вашу ситуацию с нашими Международными частными банкирами."
        },
        faq3: {
            title: "Могу ли я перевести свой существующий инвестиционный портфель в банк?",
            text: "Да, можете. Клиенты банка могут переводить свой существующий инвестиционный портфель — акции, облигации, ПИФы, драгоценные металлы, цифровые активы, частный капитал и другие продукты — через наше сотрудничество с различными глобальными банками-кассаторами. Ваш Международный частный банкир поможет организовать перевод и сообщит вам точные процедуры, зависящие от типа активов."
        },
        faq4: {
            title: "Может ли банк помочь мне зарегистрировать новую компанию или траст?",
            text: "Сам банк напрямую не занимается регистрацией, но мы тесно сотрудничаем с агентами по инкорпорации в различных юрисдикциях. Это позволяет нам проводить проверку (вам потребуется предоставить один комплект документов) и открыть счет в тот же день, когда выдается свидетельство о регистрации. Во многих случаях выгоднее открыть корпоративный, а не личный счет. Пожалуйста, обсудите ваши требования с вашим Международным частным банкиром Wall Street Ibu."
        },
        faq5: {
            title: "Каковы ваши инструкции по проводкам для входящих SWIFT-переводов?",
            text: "Все счета Wall Street Ibu являются мультивалютными и могут обрабатывать различные валюты для входящих и исходящих переводов. Международная банковская система не так совершенна, как мы. Если вы отправляете платеж без указания промежуточного банка, высок риск его потери, задержки, непреднамеренной конвертации или крупных сборов за услуги промежуточных банков, над которыми мы не контролируем. Эти банки выбираются банком-отправителем, а не Wall Street Ibu. Для получения средств мы предоставляем различные инструкции в зависимости от валюты, источника и типа платежа. Ваш Международный частный банкир отправит вам инструкции для депозитов в долларах США и евро сразу после открытия счета. Если вам нужны реквизиты для другой валюты, просто сообщите об этом."
        },
        faq6: {
            title: "Поддерживаете ли вы систему SWIFT GPI?",
            text: "Да, поддерживаем. Рекомендуем отправляющему банку использовать эту систему, если возможно. SWIFT GPI — это новое поколение платежной системы SWIFT, поддерживаемое ограниченным числом банков. Если вы или ваши контрагенты отправляете средства с помощью SWIFT GPI, вы получите уникальный UETR-код, позволяющий отслеживать статус перевода в реальном времени и видеть сборы, взимаемые агентскими банками. Как только вы узнаете об отправке платежа, просто отправьте копию вашему Международному частному банкиру. Наш отдел операций обычно сразу видит платеж в системе. К сожалению, в настоящее время у нас нет возможности для исходящих платежей по SWIFT GPI из-за нескольких используемых маршрутов. Мы планируем внедрить её в ближайшем будущем."
        },
        faq7: {
            title: "Предоставляете ли вы прямые номера IBAN?",
            text: "Да, предоставляем. IBAN (International Bank Account Number) — это стандартизированная система для номеров счетов, используемая в основном в Европе и на Ближнем Востоке. В других регионах, таких как Северная Америка или Азия, она не применяется. В настоящее время наша юрисдикция не входит в систему IBAN, но мы договорились с нашими корреспондентами в Европе об открытии виртуальных IBAN-счетов в европейских валютах, таких как EUR, GBP, CHF. Это упрощает и делает реквизиты перевода понятнее, снижая риск ошибки. Виртуальный IBAN означает, что у вас будет счет в европейском финансовом учреждении на ваше имя, а название нашего банка в реквизитах отсутствует (так называемый \"Payable Through\" счет). Однако, как только средства поступают на виртуальный счет, они сразу зачисляются на ваш мультивалютный счет Wall Street Ibu. Виртуальные IBAN – это сервис для наших клиентов частного банкинга. Наши корреспонденты могут ограничивать их использование для резидентов или граждан определённых стран. Если это относится к вам, вы всё равно можете получать SWIFT-переводы традиционным способом, используя наш SWIFT-код WSBOKMK1 или другие методы оплаты."
        },
        faq8: {
            title: "Принимаете ли вы депозиты чеками или наличными?",
            text: "Будучи цифровым банком, мы не принимаем депозиты чеками или наличными. Бумажные чеки уже не используются для международных платежей. Если вам необходимо внести наличные или чек на ваш счет Wall Street Ibu, у нас есть решения в некоторых странах через партнеров, таких как обменные пункты. Пожалуйста, уточните наличие этих услуг у вашего Международного частного банкира."
        }
    },
    fas: {
        hero: {
            title: "پرسشهای متداول",
            description: "در این بخش، پاسخهایی برای پرتکرارترین سؤالات گردآوری شدهاند تا به شما کمک کنیم خدمات ما را بهتر بشناسید و اطلاعات مورد نیازتان را سریع و مؤثر پیدا کنید. چه بهدنبال توضیحات دقیق درباره خدمات ما باشید، چه راهنمایی در حل مشکلات یا آگاهی از سیاستهای ما، این قسمت برای رفع نگرانیهای شما طراحی شده است. اگر پاسخ مورد نظرتان را پیدا نکردید، لطفا مستقیما با ما تماس بگیرید—تیم ما همیشه آمادهی کمکرسانی به شماست."
        },
        faq1: {
            title: "آیا میتوانم به صورت آنلاین برای افتتاح حساب بانکی اقدام کنم یا باید به دفاتر شما مراجعه کنم؟",
            text:
            "در این بخش، پاسخهایی برای پرتکرارترین سؤالات گردآوری شدهاند تا به شما کمک کنیم خدمات ما را بهتر بشناسید و اطلاعات مورد نیازتان را سریع و مؤثر پیدا کنید. چه بهدنبال توضیحات دقیق درباره خدمات ما باشید، چه راهنمایی در حل مشکلات یا آگاهی از سیاستهای ما، این قسمت برای رفع نگرانیهای شما طراحی شده است. اگر پاسخ مورد نظرتان را پیدا نکردید، لطفا مستقیما با ما تماس بگیرید—تیم ما همیشه آمادهی کمکرسانی به شماست"
        },
        faq2: {
            title: "آیا میتوانم به صورت آنلاین برای افتتاح حساب بانکی اقدام کنم یا باید به دفاتر شما مراجعه کنم؟",
            text: 
                "بله، شما میتوانید به صورت آنلاین درخواست دهید و تایید شوید. وال استریت ایبو یک بانک دیجیتال است. تمامی درخواستهای حساب بانکی به صورت آنلاین انجام میشود. بازدیدهای حضوری از دفتر مرکزی بانک یا هر یک از شعبههای بانک در سراسر جهان خوشآمد است، اما ضروری نیست. پس از ارسال درخواست آنلاین برای حساب، توسط افسران بانکداری خصوصی بینالمللی یا بانکداری تجاری بینالمللی بانک تماس گرفته خواهید شد تا مصاحبهای آنلاین انجام دهید و پس از آن فرایند نهایی شده و شماره حساب شما تخصیص داده خواهد شد. در وال استریت ایبو، ما به انعطافپذیری و راهحلهای سفارشی افتخار میکنیم. خدمات ما برای افراد ثروتمند و بینالمللی است که معمولاً مبلغ 1 میلیون دلار یا بیشتر را واریز میکنند. برای ما مهمترین چیز این است که رابطه تجاریمان باید به صورت دو طرفه و سودمند باشد. این امر کاملاً منصفانه است و به هر دو طرف اعمال میشود. به دلیل سطح بالای خدمات شخصی که ارائه میدهیم و هزینههایی که بابت خدماتمان میگیریم، برای ما از لحاظ اقتصادی منطقی نیست که حسابهای خیلی کوچک را سرویسدهی کنیم. مشتریان کوچک ممکن است هزینههای ما را نامتناسب بیابند و احتمالاً بهتر است که از بانکهای داخلی در کشورهای خود یا مؤسسات فینتک /EMI/PSP استفاده کنند، نه یک بانک کاملاً تنظیمشده. با این حال، هر مورد متفاوت است و ما آگاهیم که یک حساب کوچک ممکن است در آینده کسبوکار قابل توجهی بیاورد، چرا که مشتریان ممکن است انتظار یک رویداد نقدینگی داشته باشند یا ممکن است قادر به معرفی دیگر مشتریان بزرگتر باشند. بنابراین، ما هیچ  حداقل موجودی ثابتی نداریم و خوشحالیم که حسابهایی با موجودی صفر افتتاح کنیم، به شرطی که هزینههای راهاندازی طبق تعرفه استاندارد ما پرداخت شود."
        },
        faq3: {
            title: "افتتاح حساب چقدر طول میکشد؟",
            text: 
                "ما معمولاً قادر به افتتاح حسابهای چند ارزی بانکداری خصوصی بینالمللی )حساب شخصی( در عرض 24 تا 48 ساعت و حسابهای تجاری بینالمللی در مدت 1 تا 2 هفته هستیم. در برخی موارد، در صورت نیاز فوری، ممکن است بتوان حسابها را سریعتر افتتاح کرد. از سوی دیگر، در برخی موارد، افتتاح حساب ممکن است زمان بیشتری ببرد اگر نیاز به انجام مراحل دقت اضافی باشد. لطفا شرایط فردی خود را با بانکداران خصوصی بینالمللی ما مطرح کنید"
        },
        faq4: {
            title: "آیا میتوانم سبد سرمایهگذاری فعلیام را به بانک منتقل کنم؟",
            text: 
                "بله، شما میتوانید. مشتریان بانک میتوانند پورتفوی سرمایهگذاری موجود خود را شامل سهام، اوراق قرضه، صندوقهای سرمایهگذاری مشترک، فلزات گرانبها، داراییهای دیجیتال، سهام خصوصی و سایر محصولات از طریق همکاری بانک با بانکهای نگهدارنده دارایی جهانی به بانک منتقل کنند. بانکدار خصوصی بینالمللی شما قادر خواهد بود ترتیبات لازم را انجام داده و شما را از روشهای دقیق پیگیری بسته به کلاسهای دارایی موجود مطلع سازد."
        },
        faq5: {
            title: "آیا بانک میتواند در ثبت شرکت یا موسسه اعتباری جدید به من کمک کند؟",
            text:
                "بانک بهطور مستقیم اقدام به ثبت شرکتها نمیکند، اما ما با دقت با عوامل ثبت شرکت در حوزههای قضائی مختلفی که در آن فعالیت داریم، همکاری نزدیک داریم. این امر به ما این امکان را میدهد که مراحل دقت (due diligence) را به اشتراک بگذاریم شما تنها نیاز به ارائه یک مجموعه مدارک دارید( و حساب بانکی در همان روزی که گواهی ثبت شرکت صادر میشود، آماده باشد. در بسیاری از موارد، برای یک مشتری ممکن است مفیدتر باشد که حساب شرکتی به جای حساب شخصی افتتاح کند. لطفا نیازهای فردی خود را با بانکدار خصوصی بینالمللی وال استریت ایبو مطرح کنید"
        },
        faq6: {
            title: "دستورالعملهای حواله بانکی شما برای حوالههای ورودی سوئیفت چیست؟",
            text:
                "تمامی حسابهای وال استریت ایبو، حسابهای چند ارزی هستند و قادر به مدیریت ارزهای مختلف برای انتقالات ورودی و خروجی میباشند. متأسفانه، سیستم بانکداری بینالمللی به پیشرفت ما نیست. اگر پرداختها را بدون اطلاعات بانک واسطه ارسال کنید، احتمال زیادی وجود دارد که آنها از دست بروند، با تأخیر مواجه شوند، به طور ناخواسته به ارز دیگری تبدیل شوند و یا هزینههای زیادی از طریق بانکهای واسطه کسر شود که ما کنترلی روی آنها نداریم. این بانکهای واسطه توسط بانکی که وجوه را ارسال میکند انتخاب میشوند، نه وال استریت ایبو. برای دریافت وجه در حساب شما، بنابراین لازم است که دستورالعملهای مختلفی را بسته به عواملی مانند ارز، منبع و نوع پرداخت شما ارائه دهیم. بانکدار خصوصی بینالمللی شما در وال استریت ایبو دستورالعملهای مربوط به واریز دلار آمریکا و یورو را به محض افتتاح حساب شما ارسال خواهد کرد. اگر به دستورالعملهای حواله برای ارز دیگری نیاز دارید، کافیست درخواست کنید"
        },
        faq7: {
            title: "آیا شمارههای IBAN مستقیم ارائه میدهید؟",
            text:
                "بله، ما این امکان را داریم . IBAN مخفف “International Bank Account Number” است و یک سیستم استاندارد برای شماره حسابها است که عمدتا در اروپا و خاورمیانه استفاده میشود. این سیستم در دیگر بازارهای عمده مانند آمریکای شمالی یا آسیا استفاده نمیشود. در حال حاضر حوزه قضائی ما بخشی از سیستم IBAN نیست، اما ما ترتیبی دادهایم تا با همکاران خود در اروپا، حسابهای مجازی IBAN در ارزهای اروپایی مانند یورو (EUR) ، پوند انگلیس (GBP) ، و فرانک سوئیس (CHF) ارائه دهیم. مزیت این کار این است که دستورالعملهای حواله شما سادهتر و شفافتر خواهند بود که احتمال خطا را کاهش میدهد . یک حساب IBAN مجازی به این معناست که شما ظاهراً یک حساب در یک مؤسسه مالی اروپایی به نام خود خواهید داشت و نام بانک ما در اطلاعات حساب ظاهر نخواهد شد. این نوع حساب همچنین به نام حساب “Payable Through” شناخته میشود. با این حال، به محض این که وجوه به حساب مجازی وارد شوند، فوراً به حساب چند ارزی وال استریت ایبو شما واریز خواهند شد. حسابهای IBAN مجازی یک سرویس راحتی برای مشتریان بانکداری خصوصی ما هستند. همکاران ما ممکن است استفاده از این حسابها را برای ساکنان یا اتباع کشورهای خاص محدود کنند. اگر این محدودیت برای شما وجود داشته باشد، همچنان میتوانید از طریق روشهای معمول مانند کد SWIFT ما (WSBOKMK1) یا سایر روشهای پرداخت انتقالهای SWIFT را دریافت کنید ."
        },
        faq8: {
            title: "چک قبول می کنید یا پول نقد؟",
            text:
                "به عنوان یک بانک دیجیتال، ما هیچگونه واریز نقدی یا چکی را قبول نمیکنیم. چکهای کاغذی دیگر برای پرداختهای بینالمللی بهطور رایج استفاده نمیشوند. اگر نیاز دارید که وجوه را از طریق نقدی یا چک به حساب وال استریت ایبو خود واریز کنید، ما دربرخی کشورها از طریق شرکای ثالث مانند دفاتر صرافی یا دفاتر “cambio” راهحلهایی داریم. لطفا در مورد در دسترس بودن این خدمات با بانکدار خصوصی بینالمللی خود مشورت کنید."
        }
    },
}

const footerTranslations = {
    en: {
        license: {
            title: "License Number",
            alt: "Mwali Security Logo",
            number: "B2022083",
            link: "Link to license"
        },
        legal: {
            title: "Legal Information",
            privacyPolicy: "Privacy Policy",
            termsAndConditions: "Website Terms and Conditions",
            corporateGovernance: "Corporate Governance",
            cookiePolicy: "Cookie Policy",
            bankTransactionsTerms: "Bank Transactions Terms",
            debitCardTerms: "Debit Card Terms",
            standardFeesTariff: "Standard Fees Tariff"
        },
        services: {
            title: "Our Services",
            home: "Home",
            fxTrade: "FX Trade"
        },
        contact: {
            title: "Contact Info",
            addressIconAlt: "Address Icon",
            address1: "No. 802 Renmin Avenue, Changchun City, Jilin Province",
            mailIconAlt: "Mail Icon",
            phoneIconAlt: "Phone Icon",
        },
    },
    ru: {
        license: {
            title: "Номер лицензии",
            alt: "Логотип Mwali Security",
            number: "B2022083",
            link: "Ссылка на лицензию"
        },
        legal: {
            title: "Юридическая информация",
            privacyPolicy: "Политика конфиденциальности",
            termsAndConditions: "Условия использования сайта",
            corporateGovernance: "Корпоративное управление",
            cookiePolicy: "Политика использования файлов cookie",
            bankTransactionsTerms: "Условия банковских транзакций",
            debitCardTerms: "Условия использования дебетовой карты",
            standardFeesTariff: "Стандартный тариф сборов"
        },
        services: {
            title: "Наши услуги",
            home: "Главная",
            fxTrade: "FX Trade"
        },
        contact: {
            title: "Контактная информация",
            addressIconAlt: "Иконка адреса",
            address1: "No. 802 Renmin Avenue, Changchun City, Jilin Province",
            mailIconAlt: "Иконка почты",
            phoneIconAlt: "Иконка телефона",
        },
    },
    fas: {
        license: {
            title: "شماره مجوز",
            alt: "Mwali Security Logo",
            number: "B2022083",
            link: "لینک مجوز"
        },
        legal: {
            title: "اطلاعات حقوقی",
            privacyPolicy: "سیاست حفظ حریم خصوصی",
            termsAndConditions: "شرایط و ضوابط سایت",
            corporateGovernance: "حاکمیت شرکتی",
            cookiePolicy: "خط مشی کوکی",
            bankTransactionsTerms: "شرایط و ضوابط بانکی",
            debitCardTerms: "شرایط استفاده از کارت نقدی",
            standardFeesTariff: "نرخ شارژ استاندارد"
        },
        services: {
            title: "خدمات ما",
            home: "صفحه اصلی",
            fxTrade: "FX Trade"
        },
        contact: {
            title: "اطلاعات تماس",
            addressIconAlt: "Address Icon",
            address1: "شماره 802 ، خیابان رنمین، شهر چانگچون، استان جیلین، چین",
            mailIconAlt: "Mail Icon",
            phoneIconAlt: "Phone Icon",
        },
    },
};

const mobileMenuTranslations = {
    en: {
        home: "Home",
        legalInformation: "Legal information",
        openAccount: "Open Account",
        logIn: "Log In",
        copyright: "© 2024 Wall Street Ibu"
    },
    ru: {
        home: "Главная",
        legalInformation: "Юридическая информация",
        openAccount: "Открыть счет",
        logIn: "Войти",
        copyright: "© 2024 Wall Street Ibu"
    },
    fas: {
        home: "صفحه اصلی",
        legalInformation: "اطلاعات حقوقی",
        openAccount: "یک حساب باز کنید",
        logIn: "وارد شوید",
        copyright: "© 2024 Wall Street Ibu"
    }
};

const resources = {
    en: {
        translation: {
            home: homeTranslations.en,
            routes: routesTranslations.en,
            header: headerTranslations.en,
            common: commonTranslations.en,
            hero: heroTranslations.en,
            homePage: homePageTranslations.en,
            contactPage: contactPageTranslations.en,
            contactUsForm: contactUsFormTranslations.en,
            aboutUsPage: aboutUsPageTranslations.en,
            privateBanking: privateBankingTranslations.en,
            commercialBanking: commercialBankingTranslations.en,
            cards: cardsTranslations.en,
            digitalAssetsBanking: digitalAssetsBankingTranslations.en,
            tradeFinance: tradeFinanceTranslations.en,
            faq: faqTranslations.en,
            footer: footerTranslations.en,
            mobileMenu: mobileMenuTranslations.en,
        }
    },
    ru: {
        translation: {
            home: homeTranslations.ru,
            routes: routesTranslations.ru,
            header: headerTranslations.ru,
            common: commonTranslations.ru,
            hero: heroTranslations.ru,
            homePage: homePageTranslations.ru,
            contactPage: contactPageTranslations.ru,
            contactUsForm: contactUsFormTranslations.ru,
            aboutUsPage: aboutUsPageTranslations.ru,
            privateBanking: privateBankingTranslations.ru,
            commercialBanking: commercialBankingTranslations.ru,
            cards: cardsTranslations.ru,
            digitalAssetsBanking: digitalAssetsBankingTranslations.ru,
            tradeFinance: tradeFinanceTranslations.ru,
            faq: faqTranslations.ru,
            footer: footerTranslations.ru,
            mobileMenu: mobileMenuTranslations.ru
        }
    },
    fas: {
        translation: {
            home: homeTranslations.fas,
            routes: routesTranslations.fas,
            header: headerTranslations.fas,
            hero: heroTranslations.fas,
            homePage: homePageTranslations.fas,
            contactPage: contactPageTranslations.fas,
            contactUsForm: contactUsFormTranslations.fas,
            aboutUsPage: aboutUsPageTranslations.fas,
            privateBanking: privateBankingTranslations.fas,
            commercialBanking: commercialBankingTranslations.fas,
            cards: cardsTranslations.fas,
            digitalAssetsBanking: digitalAssetsBankingTranslations.fas,
            tradeFinance: tradeFinanceTranslations.fas,
            faq: faqTranslations.fas,
            footer: footerTranslations.fas,
            mobileMenu: mobileMenuTranslations.fas
        }
    },
};


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
